//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IBuildingClient {
  get(id: string): Observable<ApiBuilding>;
}

@Injectable()
export class BuildingClient implements IBuildingClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  get(id: string): Observable<ApiBuilding> {
    let url_ = this.baseUrl + '/formulare/Building/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiBuilding>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiBuilding>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiBuilding> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiBuilding);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IBusinessUnitClient {
  get(id: string): Observable<ApiBusinessUnit>;
  filter(search: string | null | undefined): Observable<ApiBusinessUnitBasic[]>;
}

@Injectable()
export class BusinessUnitClient implements IBusinessUnitClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  get(id: string): Observable<ApiBusinessUnit> {
    let url_ = this.baseUrl + '/formulare/BusinessUnitController/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiBusinessUnit>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiBusinessUnit>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiBusinessUnit> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiBusinessUnit);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  filter(search: string | null | undefined): Observable<ApiBusinessUnitBasic[]> {
    let url_ = this.baseUrl + '/formulare/BusinessUnitController/filter?';
    if (search !== undefined && search !== null)
      url_ += 'search=' + encodeURIComponent('' + search) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFilter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFilter(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiBusinessUnitBasic[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiBusinessUnitBasic[]>;
        })
      );
  }

  protected processFilter(response: HttpResponseBase): Observable<ApiBusinessUnitBasic[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiBusinessUnitBasic[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface ICraftClient {
  get(): Observable<ApiCraft[]>;
}

@Injectable()
export class CraftClient implements ICraftClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  get(): Observable<ApiCraft[]> {
    let url_ = this.baseUrl + '/formulare/craft';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiCraft[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiCraft[]>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiCraft[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiCraft[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface ICustomizableTextClient {
  getCustomizableTextList(): Observable<CustomizableTextViewModel[]>;
  getCustomizableText(request: GetCustomizableTextRequest): Observable<CustomizableTextViewModel>;
  updateCustomizableText(
    updateCustomizableTextDTO: UpdateCustomizableTextRequestDTO
  ): Observable<void>;
}

@Injectable()
export class CustomizableTextClient implements ICustomizableTextClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getCustomizableTextList(): Observable<CustomizableTextViewModel[]> {
    let url_ = this.baseUrl + '/api/CustomizableText/GetCustomizableTextList';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCustomizableTextList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCustomizableTextList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CustomizableTextViewModel[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<CustomizableTextViewModel[]>;
        })
      );
  }

  protected processGetCustomizableTextList(
    response: HttpResponseBase
  ): Observable<CustomizableTextViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CustomizableTextViewModel[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getCustomizableText(request: GetCustomizableTextRequest): Observable<CustomizableTextViewModel> {
    let url_ = this.baseUrl + '/api/CustomizableText/GetCustomizableText';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCustomizableText(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCustomizableText(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CustomizableTextViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<CustomizableTextViewModel>;
        })
      );
  }

  protected processGetCustomizableText(
    response: HttpResponseBase
  ): Observable<CustomizableTextViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CustomizableTextViewModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  updateCustomizableText(
    updateCustomizableTextDTO: UpdateCustomizableTextRequestDTO
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/CustomizableText/UpdateCustomizableText';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateCustomizableTextDTO);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCustomizableText(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCustomizableText(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUpdateCustomizableText(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }
}

export interface IEquipmenmtClarificationClient {
  getRequestReasonEnums(): Observable<EnumOptionDTO[]>;
  getTechnicTypeEnums(): Observable<EnumOptionDTO[]>;
  create(
    receiverEmail: string | null | undefined,
    eqClassification: ApiEquipmentClassification
  ): Observable<FileResponse>;
}

@Injectable()
export class EquipmenmtClarificationClient implements IEquipmenmtClarificationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getRequestReasonEnums(): Observable<EnumOptionDTO[]> {
    let url_ = this.baseUrl + '/api/EquipmenmtClarification/RequestReasonEnums';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRequestReasonEnums(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRequestReasonEnums(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EnumOptionDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<EnumOptionDTO[]>;
        })
      );
  }

  protected processGetRequestReasonEnums(response: HttpResponseBase): Observable<EnumOptionDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as EnumOptionDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  getTechnicTypeEnums(): Observable<EnumOptionDTO[]> {
    let url_ = this.baseUrl + '/api/EquipmenmtClarification/TechnicTypeEnums';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTechnicTypeEnums(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTechnicTypeEnums(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EnumOptionDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<EnumOptionDTO[]>;
        })
      );
  }

  protected processGetTechnicTypeEnums(response: HttpResponseBase): Observable<EnumOptionDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as EnumOptionDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  create(
    receiverEmail: string | null | undefined,
    eqClassification: ApiEquipmentClassification
  ): Observable<FileResponse> {
    let url_ = this.baseUrl + '/api/EquipmenmtClarification?';
    if (receiverEmail !== undefined && receiverEmail !== null)
      url_ += 'receiverEmail=' + encodeURIComponent('' + receiverEmail) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(eqClassification);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/octet-stream',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({
        fileName: fileName,
        data: responseBlob as any,
        status: status,
        headers: _headers,
      });
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }
}

export interface IFileClient {
  uploadFile(files: UploadFile[]): Observable<UploadFileResult[]>;
  downloadFile(
    contentType: string | null | undefined,
    requestedFile: DownloadFile
  ): Observable<FileResponse>;
  /**
   * @deprecated
   */
  getFileLink(requestedFile: DownloadFile): Observable<DownloadFileResult>;
}

@Injectable()
export class FileClient implements IFileClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  uploadFile(files: UploadFile[]): Observable<UploadFileResult[]> {
    let url_ = this.baseUrl + '/api/File/UploadFile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(files);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadFile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UploadFileResult[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UploadFileResult[]>;
        })
      );
  }

  protected processUploadFile(response: HttpResponseBase): Observable<UploadFileResult[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UploadFileResult[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  downloadFile(
    contentType: string | null | undefined,
    requestedFile: DownloadFile
  ): Observable<FileResponse> {
    let url_ = this.baseUrl + '/api/File/DownloadFile?';
    if (contentType !== undefined && contentType !== null)
      url_ += 'contentType=' + encodeURIComponent('' + contentType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(requestedFile);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/octet-stream',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownloadFile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownloadFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processDownloadFile(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({
        fileName: fileName,
        data: responseBlob as any,
        status: status,
        headers: _headers,
      });
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  /**
   * @deprecated
   */
  getFileLink(requestedFile: DownloadFile): Observable<DownloadFileResult> {
    let url_ = this.baseUrl + '/api/File/GetFileLink';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(requestedFile);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFileLink(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFileLink(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DownloadFileResult>;
            }
          } else return _observableThrow(response_) as any as Observable<DownloadFileResult>;
        })
      );
  }

  protected processGetFileLink(response: HttpResponseBase): Observable<DownloadFileResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DownloadFileResult);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }
}

export interface IHealthClient {
  get(): Observable<void>;
}

@Injectable()
export class HealthClient implements IHealthClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  get(): Observable<void> {
    let url_ = this.baseUrl + '/api/Health';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IIncidentClient {
  createIncident(incidentDTO: CreateIncidentFromPortalDTO): Observable<string>;
  createIncidentAuthenticated(
    incidentDTO: CreateIncidentAuthenticatedFromPortalDTO
  ): Observable<string>;
  createPasmIncidentAuthenticated(incidentDTO: CreatePasmIncidentRequestDTO): Observable<string>;
  requestOfferingReservation(
    incidentDTO: CreateOfferingReservationFromPortalDTO
  ): Observable<string>;
  getIncidentAuthenticated(id: string | null | undefined): Observable<IncidentViewModel>;
  getIncidentByTicketIdAuthenticated(id: string | null | undefined): Observable<IncidentViewModel>;
  getIncidentsAuthenticated(
    searchOptions: IncidentSearchOptions
  ): Observable<ResultWrapperOfIncidentViewModel>;
  requestRentalcontractTermination(
    terminationDTO: AddContractTerminationRequestDTO
  ): Observable<string>;
  getIncidentWithEmail(getIncidentDTO: GetIncidentDTO): Observable<FmIncident>;
}

@Injectable()
export class IncidentClient implements IIncidentClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  createIncident(incidentDTO: CreateIncidentFromPortalDTO): Observable<string> {
    let url_ = this.baseUrl + '/api/Incident/CreateIncident';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(incidentDTO);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateIncident(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateIncident(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processCreateIncident(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  createIncidentAuthenticated(
    incidentDTO: CreateIncidentAuthenticatedFromPortalDTO
  ): Observable<string> {
    let url_ = this.baseUrl + '/api/Incident/CreateIncidentAuthenticated';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(incidentDTO);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateIncidentAuthenticated(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateIncidentAuthenticated(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processCreateIncidentAuthenticated(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  createPasmIncidentAuthenticated(incidentDTO: CreatePasmIncidentRequestDTO): Observable<string> {
    let url_ = this.baseUrl + '/api/Incident/CreatePasmIncidentAuthenticated';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(incidentDTO);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreatePasmIncidentAuthenticated(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreatePasmIncidentAuthenticated(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processCreatePasmIncidentAuthenticated(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  requestOfferingReservation(
    incidentDTO: CreateOfferingReservationFromPortalDTO
  ): Observable<string> {
    let url_ = this.baseUrl + '/api/Incident/RequestOfferingReservation';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(incidentDTO);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRequestOfferingReservation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRequestOfferingReservation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processRequestOfferingReservation(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 406) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result406: any = null;
          result406 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result406
          );
        })
      );
    } else if (status === 504) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result504: any = null;
          result504 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result504
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getIncidentAuthenticated(id: string | null | undefined): Observable<IncidentViewModel> {
    let url_ = this.baseUrl + '/api/Incident/GetIncidentAuthenticated?';
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetIncidentAuthenticated(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetIncidentAuthenticated(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IncidentViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<IncidentViewModel>;
        })
      );
  }

  protected processGetIncidentAuthenticated(
    response: HttpResponseBase
  ): Observable<IncidentViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as IncidentViewModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getIncidentByTicketIdAuthenticated(id: string | null | undefined): Observable<IncidentViewModel> {
    let url_ = this.baseUrl + '/api/Incident/GetIncidentByTicketIdAuthenticated?';
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetIncidentByTicketIdAuthenticated(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetIncidentByTicketIdAuthenticated(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IncidentViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<IncidentViewModel>;
        })
      );
  }

  protected processGetIncidentByTicketIdAuthenticated(
    response: HttpResponseBase
  ): Observable<IncidentViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as IncidentViewModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getIncidentsAuthenticated(
    searchOptions: IncidentSearchOptions
  ): Observable<ResultWrapperOfIncidentViewModel> {
    let url_ = this.baseUrl + '/api/Incident/GetIncidentsAuthenticated';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(searchOptions);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetIncidentsAuthenticated(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetIncidentsAuthenticated(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResultWrapperOfIncidentViewModel>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ResultWrapperOfIncidentViewModel>;
        })
      );
  }

  protected processGetIncidentsAuthenticated(
    response: HttpResponseBase
  ): Observable<ResultWrapperOfIncidentViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ResultWrapperOfIncidentViewModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          result403 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result403
          );
        })
      );
    } else if (status === 424) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result424: any = null;
          result424 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result424
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  requestRentalcontractTermination(
    terminationDTO: AddContractTerminationRequestDTO
  ): Observable<string> {
    let url_ = this.baseUrl + '/api/Incident/RequestRentalcontractTermination';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(terminationDTO);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRequestRentalcontractTermination(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRequestRentalcontractTermination(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processRequestRentalcontractTermination(
    response: HttpResponseBase
  ): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getIncidentWithEmail(getIncidentDTO: GetIncidentDTO): Observable<FmIncident> {
    let url_ = this.baseUrl + '/api/Incident/GetIncidentWithEmail';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(getIncidentDTO);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetIncidentWithEmail(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetIncidentWithEmail(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FmIncident>;
            }
          } else return _observableThrow(response_) as any as Observable<FmIncident>;
        })
      );
  }

  protected processGetIncidentWithEmail(response: HttpResponseBase): Observable<FmIncident> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FmIncident);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }
}

export interface ILocationClient {
  searchArchobjForAutocomplete(
    searchterm: string | null | undefined,
    searchBuildings: boolean | undefined,
    searchOnlyWE: boolean | undefined
  ): Observable<ResultWrapperOfArchObjAutocompleteViewModel>;
  searchArchobjForAutoCompleteInexact(
    searchterm: string | null | undefined
  ): Observable<ResultWrapperOfArchObjAutocompleteViewModel>;
  getArchobjById(id: string | null | undefined): Observable<ArchObjHierarchyViewModel>;
  postUpdateLocationInformation(model: ArchObjInformationViewModel): Observable<void>;
  postUpdateLocationHints(model: ArchObjNewsViewModel): Observable<void>;
}

@Injectable()
export class LocationClient implements ILocationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  searchArchobjForAutocomplete(
    searchterm: string | null | undefined,
    searchBuildings: boolean | undefined,
    searchOnlyWE: boolean | undefined
  ): Observable<ResultWrapperOfArchObjAutocompleteViewModel> {
    let url_ = this.baseUrl + '/api/Location/SearchArchobjForAutocomplete?';
    if (searchterm !== undefined && searchterm !== null)
      url_ += 'searchterm=' + encodeURIComponent('' + searchterm) + '&';
    if (searchBuildings === null)
      throw new Error("The parameter 'searchBuildings' cannot be null.");
    else if (searchBuildings !== undefined)
      url_ += 'searchBuildings=' + encodeURIComponent('' + searchBuildings) + '&';
    if (searchOnlyWE === null) throw new Error("The parameter 'searchOnlyWE' cannot be null.");
    else if (searchOnlyWE !== undefined)
      url_ += 'searchOnlyWE=' + encodeURIComponent('' + searchOnlyWE) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchArchobjForAutocomplete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchArchobjForAutocomplete(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ResultWrapperOfArchObjAutocompleteViewModel>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ResultWrapperOfArchObjAutocompleteViewModel>;
        })
      );
  }

  protected processSearchArchobjForAutocomplete(
    response: HttpResponseBase
  ): Observable<ResultWrapperOfArchObjAutocompleteViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ResultWrapperOfArchObjAutocompleteViewModel);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  searchArchobjForAutoCompleteInexact(
    searchterm: string | null | undefined
  ): Observable<ResultWrapperOfArchObjAutocompleteViewModel> {
    let url_ = this.baseUrl + '/api/Location/SearchArchobjForAutoCompleteInexact?';
    if (searchterm !== undefined && searchterm !== null)
      url_ += 'searchterm=' + encodeURIComponent('' + searchterm) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchArchobjForAutoCompleteInexact(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchArchobjForAutoCompleteInexact(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ResultWrapperOfArchObjAutocompleteViewModel>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ResultWrapperOfArchObjAutocompleteViewModel>;
        })
      );
  }

  protected processSearchArchobjForAutoCompleteInexact(
    response: HttpResponseBase
  ): Observable<ResultWrapperOfArchObjAutocompleteViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ResultWrapperOfArchObjAutocompleteViewModel);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getArchobjById(id: string | null | undefined): Observable<ArchObjHierarchyViewModel> {
    let url_ = this.baseUrl + '/api/Location/GetArchobjById?';
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetArchobjById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetArchobjById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ArchObjHierarchyViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ArchObjHierarchyViewModel>;
        })
      );
  }

  protected processGetArchobjById(
    response: HttpResponseBase
  ): Observable<ArchObjHierarchyViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ArchObjHierarchyViewModel);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  postUpdateLocationInformation(model: ArchObjInformationViewModel): Observable<void> {
    let url_ = this.baseUrl + '/api/Location/PostUpdateLocationInformation';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPostUpdateLocationInformation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPostUpdateLocationInformation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processPostUpdateLocationInformation(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 406) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result406: any = null;
          result406 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result406
          );
        })
      );
    } else if (status === 504) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result504: any = null;
          result504 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result504
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  postUpdateLocationHints(model: ArchObjNewsViewModel): Observable<void> {
    let url_ = this.baseUrl + '/api/Location/PostUpdateLocationHints';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPostUpdateLocationHints(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPostUpdateLocationHints(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processPostUpdateLocationHints(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 406) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result406: any = null;
          result406 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result406
          );
        })
      );
    } else if (status === 504) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result504: any = null;
          result504 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result504
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }
}

export interface ILocationForecastClient {
  create(request: ApiRequest): Observable<FileResponse>;
  getLogList(): Observable<FileResponse>;
}

@Injectable()
export class LocationForecastClient implements ILocationForecastClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  create(request: ApiRequest): Observable<FileResponse> {
    let url_ = this.baseUrl + '/formulare/standortprognose';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/octet-stream',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({
        fileName: fileName,
        data: responseBlob as any,
        status: status,
        headers: _headers,
      });
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  getLogList(): Observable<FileResponse> {
    let url_ = this.baseUrl + '/formulare/standortprognose';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/octet-stream',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLogList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLogList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processGetLogList(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({
        fileName: fileName,
        data: responseBlob as any,
        status: status,
        headers: _headers,
      });
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IOfferingClient {
  getExposes(searchOptions: OfferingSearchOptions): Observable<ResultWrapperOfPmPropertyBrochure>;
  getExposeById(exposeId: string | null | undefined): Observable<PmPropertyBrochure>;
}

@Injectable()
export class OfferingClient implements IOfferingClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getExposes(searchOptions: OfferingSearchOptions): Observable<ResultWrapperOfPmPropertyBrochure> {
    let url_ = this.baseUrl + '/api/Offering/GetExposes';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(searchOptions);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetExposes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetExposes(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResultWrapperOfPmPropertyBrochure>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ResultWrapperOfPmPropertyBrochure>;
        })
      );
  }

  protected processGetExposes(
    response: HttpResponseBase
  ): Observable<ResultWrapperOfPmPropertyBrochure> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ResultWrapperOfPmPropertyBrochure);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  getExposeById(exposeId: string | null | undefined): Observable<PmPropertyBrochure> {
    let url_ = this.baseUrl + '/api/Offering/GetExposeById?';
    if (exposeId !== undefined && exposeId !== null)
      url_ += 'exposeId=' + encodeURIComponent('' + exposeId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetExposeById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetExposeById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PmPropertyBrochure>;
            }
          } else return _observableThrow(response_) as any as Observable<PmPropertyBrochure>;
        })
      );
  }

  protected processGetExposeById(response: HttpResponseBase): Observable<PmPropertyBrochure> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as PmPropertyBrochure);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IOptionSetClient {
  getLocationFilterOptionSet(): Observable<LocationFilterOptionSet[]>;
  getLocationFilterHierarchy(): Observable<LocationFilterHierarchy[]>;
  getOptionSetAnonymous(type: EnumType | undefined): Observable<SysEnum[]>;
  getOptionSetByString(type: string | null | undefined): Observable<SysEnum[]>;
  getHolidayList(): Observable<string[]>;
}

@Injectable()
export class OptionSetClient implements IOptionSetClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getLocationFilterOptionSet(): Observable<LocationFilterOptionSet[]> {
    let url_ = this.baseUrl + '/api/OptionSet/GetLocationFilterOptionSet';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLocationFilterOptionSet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLocationFilterOptionSet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LocationFilterOptionSet[]>;
            }
          } else return _observableThrow(response_) as any as Observable<LocationFilterOptionSet[]>;
        })
      );
  }

  protected processGetLocationFilterOptionSet(
    response: HttpResponseBase
  ): Observable<LocationFilterOptionSet[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as LocationFilterOptionSet[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  getLocationFilterHierarchy(): Observable<LocationFilterHierarchy[]> {
    let url_ = this.baseUrl + '/api/OptionSet/GetLocationFilterHierarchy';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLocationFilterHierarchy(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLocationFilterHierarchy(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LocationFilterHierarchy[]>;
            }
          } else return _observableThrow(response_) as any as Observable<LocationFilterHierarchy[]>;
        })
      );
  }

  protected processGetLocationFilterHierarchy(
    response: HttpResponseBase
  ): Observable<LocationFilterHierarchy[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as LocationFilterHierarchy[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getOptionSetAnonymous(type: EnumType | undefined): Observable<SysEnum[]> {
    let url_ = this.baseUrl + '/api/OptionSet/GetOptionSetAnonymous?';
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += 'type=' + encodeURIComponent('' + type) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetOptionSetAnonymous(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetOptionSetAnonymous(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SysEnum[]>;
            }
          } else return _observableThrow(response_) as any as Observable<SysEnum[]>;
        })
      );
  }

  protected processGetOptionSetAnonymous(response: HttpResponseBase): Observable<SysEnum[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SysEnum[]);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getOptionSetByString(type: string | null | undefined): Observable<SysEnum[]> {
    let url_ = this.baseUrl + '/api/OptionSet/GetOptionSetByString?';
    if (type !== undefined && type !== null) url_ += 'type=' + encodeURIComponent('' + type) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetOptionSetByString(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetOptionSetByString(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SysEnum[]>;
            }
          } else return _observableThrow(response_) as any as Observable<SysEnum[]>;
        })
      );
  }

  protected processGetOptionSetByString(response: HttpResponseBase): Observable<SysEnum[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SysEnum[]);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getHolidayList(): Observable<string[]> {
    let url_ = this.baseUrl + '/api/OptionSet/GetHolidayList';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetHolidayList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetHolidayList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        })
      );
  }

  protected processGetHolidayList(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }
}

export interface IUserClient {
  readUsers(dto: ReadUsersRequest): Observable<ReadUsersResponse>;
  readUser(dto: ReadUserRequest): Observable<ReadUserResponse>;
  updateUser(dto: UpdateUserRequest): Observable<UpdateUserResponse>;
  deleteUser(dto: DeleteUserRequest): Observable<void>;
  readGroups(dto: ReadGroupsRequest): Observable<ReadGroupsResponse>;
  addUserToGroups(dto: AddUserToGroupsRequest): Observable<AddUserToGroupsResponse>;
  removeUserFromGroups(dto: RemoveUserFromGroupsRequest): Observable<RemoveUserFromGroupsResponse>;
  getUserProfile(): Observable<OmContact>;
  getUserEmail(): Observable<string>;
  updateUserProfile(updateUserProfileDTO: UpdateUserProfileDTO): Observable<void>;
  requestRoles(request: RoleRequestDTO): Observable<boolean>;
  getRentalContractForUser(): Observable<PmRentalContract>;
}

@Injectable()
export class UserClient implements IUserClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  readUsers(dto: ReadUsersRequest): Observable<ReadUsersResponse> {
    let url_ = this.baseUrl + '/api/User/ReadUsers';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReadUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReadUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReadUsersResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReadUsersResponse>;
        })
      );
  }

  protected processReadUsers(response: HttpResponseBase): Observable<ReadUsersResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReadUsersResponse);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  readUser(dto: ReadUserRequest): Observable<ReadUserResponse> {
    let url_ = this.baseUrl + '/api/User/ReadUser';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReadUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReadUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReadUserResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReadUserResponse>;
        })
      );
  }

  protected processReadUser(response: HttpResponseBase): Observable<ReadUserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReadUserResponse);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  updateUser(dto: UpdateUserRequest): Observable<UpdateUserResponse> {
    let url_ = this.baseUrl + '/api/User/UpdateUser';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateUserResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateUserResponse>;
        })
      );
  }

  protected processUpdateUser(response: HttpResponseBase): Observable<UpdateUserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateUserResponse);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  deleteUser(dto: DeleteUserRequest): Observable<void> {
    let url_ = this.baseUrl + '/api/User/DeleteUser';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDeleteUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  readGroups(dto: ReadGroupsRequest): Observable<ReadGroupsResponse> {
    let url_ = this.baseUrl + '/api/User/ReadGroups';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReadGroups(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReadGroups(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReadGroupsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReadGroupsResponse>;
        })
      );
  }

  protected processReadGroups(response: HttpResponseBase): Observable<ReadGroupsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReadGroupsResponse);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  addUserToGroups(dto: AddUserToGroupsRequest): Observable<AddUserToGroupsResponse> {
    let url_ = this.baseUrl + '/api/User/AddUserToGroups';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddUserToGroups(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddUserToGroups(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddUserToGroupsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddUserToGroupsResponse>;
        })
      );
  }

  protected processAddUserToGroups(
    response: HttpResponseBase
  ): Observable<AddUserToGroupsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddUserToGroupsResponse);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  removeUserFromGroups(dto: RemoveUserFromGroupsRequest): Observable<RemoveUserFromGroupsResponse> {
    let url_ = this.baseUrl + '/api/User/RemoveUserFromGroups';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveUserFromGroups(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveUserFromGroups(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RemoveUserFromGroupsResponse>;
            }
          } else
            return _observableThrow(response_) as any as Observable<RemoveUserFromGroupsResponse>;
        })
      );
  }

  protected processRemoveUserFromGroups(
    response: HttpResponseBase
  ): Observable<RemoveUserFromGroupsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as RemoveUserFromGroupsResponse);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getUserProfile(): Observable<OmContact> {
    let url_ = this.baseUrl + '/api/User/GetUserProfile';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserProfile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserProfile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OmContact>;
            }
          } else return _observableThrow(response_) as any as Observable<OmContact>;
        })
      );
  }

  protected processGetUserProfile(response: HttpResponseBase): Observable<OmContact> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as OmContact);
          return _observableOf(result200);
        })
      );
    } else if (status === 424) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result424: any = null;
          result424 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result424
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getUserEmail(): Observable<string> {
    let url_ = this.baseUrl + '/api/User/GetUserEmail';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserEmail(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserEmail(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processGetUserEmail(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status === 424) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result424: any = null;
          result424 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result424
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  updateUserProfile(updateUserProfileDTO: UpdateUserProfileDTO): Observable<void> {
    let url_ = this.baseUrl + '/api/User/UpdateUserProfile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateUserProfileDTO);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUserProfile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUserProfile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUpdateUserProfile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 424) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result424: any = null;
          result424 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result424
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  requestRoles(request: RoleRequestDTO): Observable<boolean> {
    let url_ = this.baseUrl + '/api/User/RequestRoles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRequestRoles(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRequestRoles(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processRequestRoles(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getRentalContractForUser(): Observable<PmRentalContract> {
    let url_ = this.baseUrl + '/api/User/GetRentalContractForUser';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRentalContractForUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRentalContractForUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PmRentalContract>;
            }
          } else return _observableThrow(response_) as any as Observable<PmRentalContract>;
        })
      );
  }

  protected processGetRentalContractForUser(
    response: HttpResponseBase
  ): Observable<PmRentalContract> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as PmRentalContract);
          return _observableOf(result200);
        })
      );
    } else if (status === 424) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result424: any = null;
          result424 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result424
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }
}

export interface IQuoteClient {
  getQuotes(searchOptions: QuoteSearchOptions): Observable<ResultWrapperOfQuoteViewModel>;
  getQuote(id: string | null | undefined): Observable<QuoteViewModel>;
  changeQuoteState(changeQuoteStateDTO: ChangeQuoteStateDTO): Observable<void>;
}

@Injectable()
export class QuoteClient implements IQuoteClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getQuotes(searchOptions: QuoteSearchOptions): Observable<ResultWrapperOfQuoteViewModel> {
    let url_ = this.baseUrl + '/api/Quote/GetQuotes';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(searchOptions);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetQuotes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetQuotes(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResultWrapperOfQuoteViewModel>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ResultWrapperOfQuoteViewModel>;
        })
      );
  }

  protected processGetQuotes(
    response: HttpResponseBase
  ): Observable<ResultWrapperOfQuoteViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfQuoteViewModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getQuote(id: string | null | undefined): Observable<QuoteViewModel> {
    let url_ = this.baseUrl + '/api/Quote/GetQuote?';
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetQuote(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetQuote(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<QuoteViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<QuoteViewModel>;
        })
      );
  }

  protected processGetQuote(response: HttpResponseBase): Observable<QuoteViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as QuoteViewModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  changeQuoteState(changeQuoteStateDTO: ChangeQuoteStateDTO): Observable<void> {
    let url_ = this.baseUrl + '/api/Quote/ChangeQuoteState';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(changeQuoteStateDTO);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangeQuoteState(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangeQuoteState(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processChangeQuoteState(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }
}

export interface IRepresentativeClient {
  getRepresentative(): Observable<RepresentativeResponse>;
  getPossibleRepresentatives(): Observable<RepresentativeResponse[]>;
  addOrUpdateRepresentatives(
    representativeId: string | null | undefined
  ): Observable<RepresentativeResponse>;
  deleteRepresentative(): Observable<void>;
}

@Injectable()
export class RepresentativeClient implements IRepresentativeClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getRepresentative(): Observable<RepresentativeResponse> {
    let url_ = this.baseUrl + '/api/Representative/current-representative';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRepresentative(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRepresentative(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RepresentativeResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<RepresentativeResponse>;
        })
      );
  }

  protected processGetRepresentative(
    response: HttpResponseBase
  ): Observable<RepresentativeResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as RepresentativeResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  getPossibleRepresentatives(): Observable<RepresentativeResponse[]> {
    let url_ = this.baseUrl + '/api/Representative/possible-representatives';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPossibleRepresentatives(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPossibleRepresentatives(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RepresentativeResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<RepresentativeResponse[]>;
        })
      );
  }

  protected processGetPossibleRepresentatives(
    response: HttpResponseBase
  ): Observable<RepresentativeResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as RepresentativeResponse[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  addOrUpdateRepresentatives(
    representativeId: string | null | undefined
  ): Observable<RepresentativeResponse> {
    let url_ = this.baseUrl + '/api/Representative?';
    if (representativeId !== undefined && representativeId !== null)
      url_ += 'representativeId=' + encodeURIComponent('' + representativeId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddOrUpdateRepresentatives(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddOrUpdateRepresentatives(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RepresentativeResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<RepresentativeResponse>;
        })
      );
  }

  protected processAddOrUpdateRepresentatives(
    response: HttpResponseBase
  ): Observable<RepresentativeResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as RepresentativeResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  deleteRepresentative(): Observable<void> {
    let url_ = this.baseUrl + '/api/Representative';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteRepresentative(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteRepresentative(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDeleteRepresentative(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface ITaskClient {
  getTasks(searchOptions: TaskSearchOptions): Observable<ResultWrapperOfFmTask>;
  getTask(
    id: string | null | undefined,
    ignoreStatus: boolean | undefined
  ): Observable<ResultExtensionWrapperOfFmTaskAndIEnumerableOfIncidentFieldMapping>;
  updateTask(updateTaskDTO: UpdateTaskDTO): Observable<void>;
}

@Injectable()
export class TaskClient implements ITaskClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getTasks(searchOptions: TaskSearchOptions): Observable<ResultWrapperOfFmTask> {
    let url_ = this.baseUrl + '/api/Task/GetTasks';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(searchOptions);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTasks(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTasks(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResultWrapperOfFmTask>;
            }
          } else return _observableThrow(response_) as any as Observable<ResultWrapperOfFmTask>;
        })
      );
  }

  protected processGetTasks(response: HttpResponseBase): Observable<ResultWrapperOfFmTask> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfFmTask);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getTask(
    id: string | null | undefined,
    ignoreStatus: boolean | undefined
  ): Observable<ResultExtensionWrapperOfFmTaskAndIEnumerableOfIncidentFieldMapping> {
    let url_ = this.baseUrl + '/api/Task/GetTask?';
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    if (ignoreStatus === null) throw new Error("The parameter 'ignoreStatus' cannot be null.");
    else if (ignoreStatus !== undefined)
      url_ += 'ignoreStatus=' + encodeURIComponent('' + ignoreStatus) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTask(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTask(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ResultExtensionWrapperOfFmTaskAndIEnumerableOfIncidentFieldMapping>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ResultExtensionWrapperOfFmTaskAndIEnumerableOfIncidentFieldMapping>;
        })
      );
  }

  protected processGetTask(
    response: HttpResponseBase
  ): Observable<ResultExtensionWrapperOfFmTaskAndIEnumerableOfIncidentFieldMapping> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ResultExtensionWrapperOfFmTaskAndIEnumerableOfIncidentFieldMapping);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  updateTask(updateTaskDTO: UpdateTaskDTO): Observable<void> {
    let url_ = this.baseUrl + '/api/Task/UpdateTask';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateTaskDTO);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateTask(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateTask(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUpdateTask(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }
}

export interface IWorkorderClient {
  getWorkorders(
    searchOptions: WorkorderSearchOptions
  ): Observable<ResultWrapperOfWorkorderViewModel>;
  getWorkorder(id: string | null | undefined): Observable<WorkorderViewModel>;
}

@Injectable()
export class WorkorderClient implements IWorkorderClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    const http = inject<HttpClient>(HttpClient);
    const baseUrl = inject(API_BASE_URL, { optional: true });

    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getWorkorders(
    searchOptions: WorkorderSearchOptions
  ): Observable<ResultWrapperOfWorkorderViewModel> {
    let url_ = this.baseUrl + '/api/Workorder/GetWorkorders';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(searchOptions);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetWorkorders(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetWorkorders(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResultWrapperOfWorkorderViewModel>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ResultWrapperOfWorkorderViewModel>;
        })
      );
  }

  protected processGetWorkorders(
    response: HttpResponseBase
  ): Observable<ResultWrapperOfWorkorderViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ResultWrapperOfWorkorderViewModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }

  getWorkorder(id: string | null | undefined): Observable<WorkorderViewModel> {
    let url_ = this.baseUrl + '/api/Workorder/GetWorkorder?';
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetWorkorder(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetWorkorder(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<WorkorderViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<WorkorderViewModel>;
        })
      );
  }

  protected processGetWorkorder(response: HttpResponseBase): Observable<WorkorderViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as WorkorderViewModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result401
          );
        })
      );
    } else {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            resultdefault
          );
        })
      );
    }
  }
}

export interface ApiBuilding {
  displayId?: string;
  objektId?: string;
  number?: string | undefined;
  address?: ApiAddress | undefined;
  displayName?: string | undefined;
}

export interface ApiAddress {
  displayId?: string;
  street?: string | undefined;
  postcode?: string | undefined;
  city?: string | undefined;
  displayName?: string | undefined;
}

export interface ApiBusinessUnit {
  displayId?: string;
  number?: number | undefined;
  displayName?: string | undefined;
  hasStars05?: boolean;
  businessUnitAddress?: ApiAddress | undefined;
  realEstates?: ApiRealEstate[];
}

export interface ApiRealEstate {
  displayId?: string;
  objektId?: string;
  number?: string;
  displayName?: string;
  buildings?: ApiBuilding[];
}

export interface ApiBusinessUnitBasic {
  displayId?: string;
  number?: number;
  displayName?: string;
}

export interface ApiCraft {
  displayId?: string;
  description?: string;
  value?: number | undefined;
  unit?: string | undefined;
}

export interface CustomizableTextViewModel {
  id?: string;
  useCaseGroup?: string;
  useCaseDescription?: string;
  sysCustomizableTextTranslation?: CustomizableTextTranslationViewModel[] | undefined;
}

export interface CustomizableTextTranslationViewModel {
  customizableTextId?: string;
  language?: string;
  text?: string;
}

export interface ProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export interface GetCustomizableTextRequest {
  pasmIncidentType?: number;
}

export interface UpdateCustomizableTextRequestDTO {
  customizableTextId: string;
  text: string;
  language: string;
}

export interface EnumOptionDTO {
  id?: number;
  displayName?: string;
}

export interface ApiEquipmentClassification {
  siteName?: string;
  enumRequestReason?: EnumRequestReason;
  requestReasonText?: string | undefined;
  location?: string | undefined;
  room?: string | undefined;
  equipmentNr?: string | undefined;
  unit?: string | undefined;
  enumTechnicType?: EnumTechnicType;
  files?: ApiEquipmentClassificationFile[] | undefined;
}

export enum EnumRequestReason {
  Eigentuemeranfrage = 0,
  ElektrischeMedientrennung = 1,
  Zaehlersetzung = 2,
  Sonstiges = 3,
}

export enum EnumTechnicType {
  PASM = 0,
  Vermittlungstechnik = 1,
  DinglicheSicherung = 2,
}

export interface ApiEquipmentClassificationFile {
  contentbase64?: string;
  filename?: string;
}

export interface UploadFileResult {
  id: string;
  name: string;
  downloadLink?: string | undefined;
  created?: Date | undefined;
}

export interface UploadFile {
  contentBase64Encoded: string;
  metadata: FmDocument;
}

export interface FmDocument {
  documentId?: string | undefined;
  name: string;
  guidExternalSystem?: string | undefined;
  crmGuidOriginRecord?: string | undefined;
  filename: string;
  dynamicsUri?: string | undefined;
  publishDocument?: boolean | undefined;
  statusCode?: string | undefined;
  quoteId?: string | undefined;
  workOrderId?: string | undefined;
  contactId?: string | undefined;
  rentalContractId?: string | undefined;
  frameworkAgreementId?: string | undefined;
  taskId?: string | undefined;
  functionalLocationId?: string | undefined;
  accountId?: string | undefined;
  purchaseOrderId?: string | undefined;
  agreementId?: string | undefined;
  incidentId?: string | undefined;
  changeDate?: Date | undefined;
  contentType?: string | undefined;
  propertyBrochureId?: string | undefined;
  documentTypeId?: string | undefined;
  deleted?: boolean | undefined;
  blobFilename?: string | undefined;
  uploaded?: boolean | undefined;
  apiError?: string | undefined;
  apiErrorDetails?: string | undefined;
  deleteDate?: Date | undefined;
  productId?: string | undefined;
  isInternal?: boolean;
  account?: OmOrganisation | undefined;
  agreement?: FmAgreement | undefined;
  contact?: OmContact | undefined;
  documentType?: FmDocumentType | undefined;
  frameworkAgreement?: FmFrameworkAgreement | undefined;
  functionalLocation?: DtArchObjHierarchy | undefined;
  incident?: FmIncident | undefined;
  product?: FmProduct | undefined;
  propertyBrochure?: PmPropertyBrochure | undefined;
  purchaseOrder?: FmPurchaseOrder | undefined;
  quote?: FmQuote | undefined;
  rentalContract?: PmRentalContract | undefined;
  task?: FmTask | undefined;
  workOrder?: FmWorkOrder | undefined;
  document?: Document | undefined;
  pmRentalContract?: PmRentalContract[] | undefined;
}

export interface OmOrganisation {
  organisationId?: string | undefined;
  parentOrganisationId?: string | undefined;
  name?: string | undefined;
  industry?: string | undefined;
  email?: string | undefined;
  telephone?: string | undefined;
  fax?: string | undefined;
  vatNumber?: string | undefined;
  legalEntity?: boolean | undefined;
  fiscalYearStartDate?: Date | undefined;
  changeDate?: Date | undefined;
  ownershipCode?: string | undefined;
  websiteUrl?: string | undefined;
  primaryContactId?: string | undefined;
  renter?: string | undefined;
  sic?: string | undefined;
  preferredContactMethod?: string | undefined;
  doNotEmail?: boolean | undefined;
  doNotBulkEmail?: boolean | undefined;
  doNotPhone?: boolean | undefined;
  doNotFax?: boolean | undefined;
  doNotPostalmail?: boolean | undefined;
  creditLimit?: number | undefined;
  creditOnHold?: boolean | undefined;
  paymentTerms?: string | undefined;
  shippingMethod?: string | undefined;
  billingAccount?: string | undefined;
  travelChargeType?: string | undefined;
  workOrderInstruction?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  deleteDate?: Date | undefined;
  adressCommunication?: string | undefined;
  frameworkContractors?: boolean | undefined;
  startAgreement?: Date | undefined;
  endAgreement?: Date | undefined;
  renewal?: boolean | undefined;
  renewalAccepted?: boolean | undefined;
  timeframeRenewal?: number | undefined;
  endContract?: Date | undefined;
  remarks?: string | undefined;
  subcontractorPortal?: boolean | undefined;
  portaladministratorId?: string | undefined;
  parentOrganisation?: OmOrganisation | undefined;
  portaladministrator?: OmContact | undefined;
  primaryContact?: OmContact | undefined;
  bookedHall?: BookedHall[] | undefined;
  fiCostCenter?: FiCostCenter[] | undefined;
  fmAgreementBillingAccountNavigation?: FmAgreement[] | undefined;
  fmAgreementServiceAccountNavigation?: FmAgreement[] | undefined;
  fmBookableRessource?: FmBookableRessource[] | undefined;
  fmConfigurationTask?: FmConfigurationTask[] | undefined;
  fmDocument?: FmDocument[] | undefined;
  fmIncident?: FmIncident[] | undefined;
  fmIncidentOrganisationRole?: FmIncidentOrganisationRole[] | undefined;
  fmOrderInquiry?: FmOrderInquiry[] | undefined;
  fmPriceList?: FmPriceList[] | undefined;
  fmProduct?: FmProduct[] | undefined;
  fmQuote?: FmQuote[] | undefined;
  fmTask?: FmTask[] | undefined;
  fmWorkOrderBillingAccount?: FmWorkOrder[] | undefined;
  fmWorkOrderExternalServiceProvider?: FmWorkOrder[] | undefined;
  fmWorkOrderServiceAccount?: FmWorkOrder[] | undefined;
  inverseParentOrganisation?: OmOrganisation[] | undefined;
  omContact?: OmContact[] | undefined;
  omOrganisationAddress?: OmOrganisationAddress[] | undefined;
  omOrganisationArchObjRole?: OmOrganisationArchObjRole[] | undefined;
  omOrganisationRole?: OmOrganisationRole[] | undefined;
  pmRentalContractOrganisationRole?: PmRentalContractOrganisationRole[] | undefined;
}

export interface OmContact {
  contactId?: string | undefined;
  salutation?: string | undefined;
  jobTitle?: string | undefined;
  firstName?: string | undefined;
  lastName: string;
  email?: string | undefined;
  telephone?: string | undefined;
  fax?: string | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  organisationId?: string | undefined;
  mobilePhone?: string | undefined;
  nationalityId?: string | undefined;
  isRenter?: string | undefined;
  gender?: string | undefined;
  preferredContactMethod?: string | undefined;
  preferredContactMethodId?: string | undefined;
  preferredLanguageId?: string | undefined;
  familyStatus?: string | undefined;
  spousesName?: string | undefined;
  birthDate?: Date | undefined;
  anniversary?: Date | undefined;
  doNotSendMm?: boolean;
  creditLimit?: number | undefined;
  creditOnHold?: boolean;
  paymentTerms?: string | undefined;
  shippingMethod?: string | undefined;
  freightTerms?: string | undefined;
  changeDate?: Date | undefined;
  notifyingContact?: string | undefined;
  complianceGuidelinesApprovedOn?: Date | undefined;
  consentDigitalSignature?: boolean | undefined;
  deleteDate?: Date | undefined;
  entityImage?: string | undefined;
  independentCommunication?: string | undefined;
  nationality?: SysEnum | undefined;
  organisation?: OmOrganisation | undefined;
  preferredContactMethodNavigation?: SysEnum | undefined;
  preferredLanguage?: SysEnum | undefined;
  fmBookableRessource?: FmBookableRessource[] | undefined;
  fmDocument?: FmDocument[] | undefined;
  fmIncidentAdditionalContact?: FmIncident[] | undefined;
  fmIncidentContact?: FmIncident[] | undefined;
  fmIncidentContactRole?: FmIncidentContactRole[] | undefined;
  fmIncidentInterestedparty?: FmIncident[] | undefined;
  fmIncidentNotifyingContact?: FmIncident[] | undefined;
  fmIncidentPrimaryContact?: FmIncident[] | undefined;
  fmIncidentResponsibleContact?: FmIncident[] | undefined;
  fmOrderInquiry?: FmOrderInquiry[] | undefined;
  fmQuote?: FmQuote[] | undefined;
  fmTask?: FmTask[] | undefined;
  fmWorkOrderContactOnSite?: FmWorkOrder[] | undefined;
  fmWorkOrderReportedByContact?: FmWorkOrder[] | undefined;
  fmWorkOrderReporter?: FmWorkOrder[] | undefined;
  omContactAddress?: OmContactAddress[] | undefined;
  omContactArchObjRole?: OmContactArchObjRole[] | undefined;
  omContactAuthorization?: OmContactAuthorization[] | undefined;
  omContactRole?: OmContactRole[] | undefined;
  omOrganisationPortaladministrator?: OmOrganisation[] | undefined;
  omOrganisationPrimaryContact?: OmOrganisation[] | undefined;
  pmRentalContract?: PmRentalContract[] | undefined;
  pmRentalContractContactRole?: PmRentalContractContactRole[] | undefined;
}

export interface SysEnum {
  id?: string | undefined;
  type: string;
  defaultName: string;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  bookedHallBookingType?: BookedHall[] | undefined;
  bookedHallLayer?: BookedHall[] | undefined;
  bookedHallSpaceType?: BookedHall[] | undefined;
  complaint?: Complaint[] | undefined;
  dtSiteDin277?: DtSite[] | undefined;
  dtSiteLevel?: DtSite[] | undefined;
  dtSiteSoilType?: DtSite[] | undefined;
  dtSiteSuspensionPoints?: DtSite[] | undefined;
  dtSiteWindows?: DtSite[] | undefined;
  eventCharacter?: EventCharacter[] | undefined;
  eventCharacter1?: EventCharacter1[] | undefined;
  eventEventCategory?: Event[] | undefined;
  eventEventClassification?: Event[] | undefined;
  eventEventFormat?: Event[] | undefined;
  eventTargetGroup?: Event[] | undefined;
  fmIncidentCaseOriginCodeNavigation?: FmIncident[] | undefined;
  fmIncidentFacilityManagementProcessStatus?: FmIncident[] | undefined;
  fmIncidentIncidentOriginNavigation?: FmIncident[] | undefined;
  fmIncidentIncidentPriority?: FmIncident[] | undefined;
  fmIncidentPowerOfDisposition?: FmIncident[] | undefined;
  fmIncidentProfitableNavigation?: FmIncident[] | undefined;
  fmIncidentRequestTypeNavigation?: FmIncident[] | undefined;
  fmIncidentStatusNavigation?: FmIncident[] | undefined;
  fmIncidentStatusReasonNavigation?: FmIncident[] | undefined;
  fmPriceList?: FmPriceList[] | undefined;
  fmProductProductType?: FmProduct[] | undefined;
  fmProductServiceart?: FmProduct[] | undefined;
  omContactNationality?: OmContact[] | undefined;
  omContactPreferredContactMethodNavigation?: OmContact[] | undefined;
  omContactPreferredLanguage?: OmContact[] | undefined;
  productionTeam?: ProductionTeam[] | undefined;
  supplierRequest?: SupplierRequest[] | undefined;
  sysEnumTranslation?: SysEnumTranslation[] | undefined;
  workOrderPositionHall?: WorkOrderPositionHall[] | undefined;
  workOrderPrecondition?: WorkOrderPrecondition[] | undefined;
}

export interface BookedHall {
  id?: string | undefined;
  name: string;
  functionalLocationId: string;
  spaceTypeId: string;
  layerId?: string | undefined;
  eventId?: string | undefined;
  eventMatchCode?: string | undefined;
  planNumber?: string | undefined;
  spaceDetail?: string | undefined;
  bookedRoomsId?: string | undefined;
  comment?: string | undefined;
  bookingTypeId?: string | undefined;
  storno?: boolean | undefined;
  search?: string | undefined;
  subject?: string | undefined;
  number?: string | undefined;
  operatorId?: string | undefined;
  urlExhibitionAreaPlan?: string | undefined;
  exhibitionAreaGross?: number | undefined;
  exhibitionAreaNetPlan?: number | undefined;
  exhibitionAreaNetUtilization?: number | undefined;
  exhibitionAreaNet?: number | undefined;
  earlySettingUpStartDate?: Date | undefined;
  earlySettingUpEndDate?: Date | undefined;
  startDate?: Date | undefined;
  openingStartTime?: Date | undefined;
  entryStartTime?: Date | undefined;
  reservationStartDate?: Date | undefined;
  endDate?: Date | undefined;
  openingEndTime?: Date | undefined;
  reservationEndDate?: Date | undefined;
  settingUpStartDate?: Date | undefined;
  externalSettingUpStartDate?: Date | undefined;
  startEarlyConstruction?: Date | undefined;
  settingUpEndDate?: Date | undefined;
  externalSettingUpEndDate?: Date | undefined;
  endEarlyConstruction?: Date | undefined;
  internalDismantlingStartDate?: Date | undefined;
  externalDismantlingStartDate?: Date | undefined;
  internalSettingUpEndDate?: Date | undefined;
  externalDismantlingEndDate?: Date | undefined;
  bookedRooms?: Production | undefined;
  bookingType?: SysEnum | undefined;
  event?: Event | undefined;
  functionalLocation?: DtArchObjHierarchy | undefined;
  layer?: SysEnum | undefined;
  operator?: OmOrganisation | undefined;
  spaceType?: SysEnum | undefined;
  bookedHallDetailedPlanningPos?: BookedHallDetailedPlanningPos[] | undefined;
  document?: Document[] | undefined;
  workOrderPositionHall?: WorkOrderPositionHall[] | undefined;
}

export interface Production {
  id?: string | undefined;
  name: string;
  eventId?: string | undefined;
  eventNavigation?: Event | undefined;
  bookedHall?: BookedHall[] | undefined;
  complaint?: Complaint[] | undefined;
  detailedPlanning?: DetailedPlanning[] | undefined;
  detailedPlanningPos?: DetailedPlanningPos[] | undefined;
  document?: Document[] | undefined;
  event?: Event[] | undefined;
  fmWorkOrder?: FmWorkOrder[] | undefined;
  productionTeam?: ProductionTeam[] | undefined;
  workOrderPosition?: WorkOrderPosition[] | undefined;
}

export interface Event {
  id?: string | undefined;
  name: string;
  eventTypeId?: string | undefined;
  mainEventId?: string | undefined;
  assignmentMainEvent?: string | undefined;
  eventSubassignment: string;
  eventMatchCode: string;
  eventLocationId?: string | undefined;
  startDate?: Date;
  endDate?: Date;
  bookingStatusId?: string | undefined;
  eventReleased?: boolean | undefined;
  eventCategoryId?: string | undefined;
  eventClassificationId?: string | undefined;
  eventTopicId?: string | undefined;
  eventFormatId?: string | undefined;
  expectedAmountVisitors?: number | undefined;
  visitorCountCurrent?: number | undefined;
  visitorCountTarget?: number | undefined;
  areaCountTarget?: number | undefined;
  exhibitorCountTarget?: string | undefined;
  eventWebsite?: string | undefined;
  targetGroupId?: string | undefined;
  takePreviousYearsData?: boolean | undefined;
  takePreviousYearsDataDate?: Date | undefined;
  takePreviousYearsRequirements?: boolean | undefined;
  settingUpStartDateTime?: Date;
  internalSettingUpEndDateTime?: Date;
  reservationStartDate?: Date | undefined;
  reservationEndDate?: Date | undefined;
  projectmanagerId?: string | undefined;
  settingUpEndDateTime?: Date | undefined;
  externalSettingUpStartDateTime?: Date | undefined;
  externalSettingUpEndDateTime?: Date | undefined;
  externalDismantlingStartDateTime?: Date | undefined;
  externalDismantlingEndDateTime?: Date | undefined;
  internalDismantlingStartDateTime?: Date | undefined;
  entryStartTime?: Date | undefined;
  openingStartTime?: Date | undefined;
  openingEndTime?: Date | undefined;
  furtherOpeningTime?: boolean | undefined;
  commentTimes?: string | undefined;
  furtherOpeningTime2?: boolean | undefined;
  commentTimes2?: string | undefined;
  grossBudget?: number | undefined;
  sumProductFamily?: number | undefined;
  sumBudgetPosition?: number | undefined;
  costControllingId?: string | undefined;
  customerBudget?: number | undefined;
  organizerExternalId?: string | undefined;
  salesOrganizationId?: string | undefined;
  organizationalUnitId?: string | undefined;
  eventTitle?: string | undefined;
  exhibitorCountCurrent?: number | undefined;
  areaCountCurrent?: number | undefined;
  releaseDate?: Date | undefined;
  characterEventId?: string | undefined;
  reservationDate?: Date | undefined;
  quoteDate?: Date | undefined;
  exhibitorRegistrationEndDate?: Date | undefined;
  reportingDate?: Date | undefined;
  sideRoomDocumentation?: string | undefined;
  eventProductionId?: string | undefined;
  requestEspk?: boolean | undefined;
  publishToSubContractorPortal?: boolean;
  eventCategory?: SysEnum | undefined;
  eventClassification?: SysEnum | undefined;
  eventFormat?: SysEnum | undefined;
  eventProduction?: Production | undefined;
  mainEvent?: Event | undefined;
  targetGroup?: SysEnum | undefined;
  bookedHall?: BookedHall[] | undefined;
  bookedHallDetailedPlanningPos?: BookedHallDetailedPlanningPos[] | undefined;
  complaint?: Complaint[] | undefined;
  detailedPlanning?: DetailedPlanning[] | undefined;
  detailedPlanningPos?: DetailedPlanningPos[] | undefined;
  document?: Document[] | undefined;
  eventCharacter?: EventCharacter[] | undefined;
  eventTeam?: EventTeam[] | undefined;
  inverseMainEvent?: Event[] | undefined;
  production?: Production[] | undefined;
  supplierPositionHall?: SupplierPositionHall[] | undefined;
  supplierRequestPosition?: SupplierRequestPosition[] | undefined;
  workOrderPositionHall?: WorkOrderPositionHall[] | undefined;
}

export interface BookedHallDetailedPlanningPos {
  id?: string | undefined;
  bookedHallId?: string | undefined;
  detailedPlanningPosId?: string | undefined;
  eventId?: string | undefined;
  amount?: number | undefined;
  endDate?: Date | undefined;
  returnMessage?: string | undefined;
  notes?: string | undefined;
  parent?: string | undefined;
  usagePeriodStartDate?: Date | undefined;
  dispoStart?: Date | undefined;
  dispoEnd?: Date | undefined;
  usagePeriodEndDate?: Date | undefined;
  bookedHall?: BookedHall | undefined;
  detailedPlanningPos?: DetailedPlanningPos | undefined;
  event?: Event | undefined;
}

export interface DetailedPlanningPos {
  id?: string | undefined;
  name: string;
  detailedPlanningId?: string | undefined;
  eventMatchcode?: string | undefined;
  eventId?: string | undefined;
  superiorPositionId?: string | undefined;
  productFamiliyId?: string | undefined;
  productId?: string | undefined;
  amount?: number | undefined;
  notes?: string | undefined;
  parent?: string | undefined;
  tenderNecessary?: boolean | undefined;
  title?: string | undefined;
  level01?: string | undefined;
  level02?: string | undefined;
  level?: number | undefined;
  priceListId?: string | undefined;
  budgetPositionLookup?: string | undefined;
  unitPrice?: number | undefined;
  totalPrice?: number | undefined;
  productionId?: string | undefined;
  serviceProviderId?: string | undefined;
  detailedPlanning?: DetailedPlanning | undefined;
  event?: Event | undefined;
  priceList?: FmPriceList | undefined;
  production?: Production | undefined;
  bookedHallDetailedPlanningPos?: BookedHallDetailedPlanningPos[] | undefined;
  document?: Document[] | undefined;
}

export interface DetailedPlanning {
  id?: string | undefined;
  name: string;
  detailedPlanningType?: string | undefined;
  title?: string | undefined;
  requirementId?: string | undefined;
  requesterId?: string | undefined;
  eventId?: string | undefined;
  productionId?: string | undefined;
  eventmatchcode?: string | undefined;
  notes?: string | undefined;
  event?: Event | undefined;
  production?: Production | undefined;
  detailedPlanningPos?: DetailedPlanningPos[] | undefined;
  document?: Document[] | undefined;
  supplierRequest?: SupplierRequest[] | undefined;
}

export interface Document {
  id?: string | undefined;
  requirementId?: string | undefined;
  workOrderPositionId?: string | undefined;
  detailedPlanningId?: string | undefined;
  detailedPlanningPositionId?: string | undefined;
  bookedHallId?: string | undefined;
  internalOrderId?: string | undefined;
  supplierRequestId?: string | undefined;
  supplierRequestPositionId?: string | undefined;
  productionId?: string | undefined;
  eventReportId?: string | undefined;
  eventId?: string | undefined;
  bookedHall?: BookedHall | undefined;
  detailedPlanning?: DetailedPlanning | undefined;
  detailedPlanningPosition?: DetailedPlanningPos | undefined;
  event?: Event | undefined;
  idNavigation?: FmDocument | undefined;
  production?: Production | undefined;
  supplierRequest?: SupplierRequest | undefined;
  supplierRequestPosition?: SupplierRequestPosition | undefined;
  workOrderPosition?: WorkOrderPosition | undefined;
}

export interface SupplierRequest {
  id?: string | undefined;
  name?: string | undefined;
  supplierId?: string | undefined;
  detailedPlanningId?: string | undefined;
  sendToPortal?: boolean;
  sentToPortal?: boolean;
  statusId?: string | undefined;
  detailedPlanning?: DetailedPlanning | undefined;
  status?: SysEnum | undefined;
  document?: Document[] | undefined;
  supplierPositionHall?: SupplierPositionHall[] | undefined;
  supplierRequestPosition?: SupplierRequestPosition[] | undefined;
}

export interface SupplierPositionHall {
  id?: string | undefined;
  exhibitionAreaProcessId?: string | undefined;
  supplierRequestId?: string | undefined;
  eventId?: string | undefined;
  amount?: number | undefined;
  notes?: string | undefined;
  requestedFinishDate?: Date | undefined;
  dispoStart?: Date | undefined;
  startUsagePeriod?: Date | undefined;
  endUsagePeriod?: Date | undefined;
  endDispo?: Date | undefined;
  event?: Event | undefined;
  supplierRequest?: SupplierRequest | undefined;
}

export interface SupplierRequestPosition {
  id?: string | undefined;
  supplierRequestId?: string | undefined;
  eventId?: string | undefined;
  eventMatchcode?: string | undefined;
  productId?: string | undefined;
  amount?: number | undefined;
  notes?: string | undefined;
  deleteDate?: Date | undefined;
  name: string;
  title?: string | undefined;
  event?: Event | undefined;
  product?: FmProduct | undefined;
  supplierRequest?: SupplierRequest | undefined;
  document?: Document[] | undefined;
}

export interface FmProduct {
  productId?: string | undefined;
  name?: string | undefined;
  productNumber?: string | undefined;
  parentProductId?: string | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  description?: string | undefined;
  unitId?: string | undefined;
  priceListId?: string | undefined;
  currentCosts?: number | undefined;
  standardCosts?: number | undefined;
  price?: number | undefined;
  status?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  externalPrice?: number | undefined;
  serviceartId?: string | undefined;
  productTypeId?: string | undefined;
  frameworkAgreementNumber?: string | undefined;
  serviceOfMasterAgreement?: boolean | undefined;
  officialDeadlines?: number | undefined;
  organizationalDeadline?: number | undefined;
  stornoProductUntil?: number | undefined;
  budgetPositionLookup?: string | undefined;
  primaryServiceProviderId?: string | undefined;
  priceList?: FmPriceList | undefined;
  primaryServiceProvider?: OmOrganisation | undefined;
  productType?: SysEnum | undefined;
  serviceart?: SysEnum | undefined;
  unit?: FmUnit | undefined;
  fmDocument?: FmDocument[] | undefined;
  fmProductPriceList?: FmProductPriceList[] | undefined;
  fmWorkOrderProduct?: FmWorkOrderProduct[] | undefined;
  fmWorkOrderService?: FmWorkOrderService[] | undefined;
  supplierRequestPosition?: SupplierRequestPosition[] | undefined;
  workOrderPosition?: WorkOrderPosition[] | undefined;
}

export interface FmPriceList {
  priceListId?: string | undefined;
  name: string;
  deleteDate?: Date | undefined;
  beginDate?: Date | undefined;
  endDate?: Date | undefined;
  description?: string | undefined;
  stateCodeId?: string | undefined;
  serviceProviderId?: string | undefined;
  changeDate?: Date | undefined;
  serviceProvider?: OmOrganisation | undefined;
  stateCode?: SysEnum | undefined;
  detailedPlanningPos?: DetailedPlanningPos[] | undefined;
  fmProduct?: FmProduct[] | undefined;
  fmProductPriceList?: FmProductPriceList[] | undefined;
  fmQuote?: FmQuote[] | undefined;
  fmWorkOrder?: FmWorkOrder[] | undefined;
  fmWorkOrderType?: FmWorkOrderType[] | undefined;
}

export interface FmProductPriceList {
  id?: string | undefined;
  productId: string;
  priceListId: string;
  amount?: number | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  priceList?: FmPriceList | undefined;
  product?: FmProduct | undefined;
}

export interface FmQuote {
  quoteId?: string | undefined;
  name: string;
  orderInquiry?: string | undefined;
  incident?: string | undefined;
  sla?: string | undefined;
  quoteNumber?: string | undefined;
  alternateKey?: string | undefined;
  changeDate?: Date | undefined;
  billingAddressCity?: string | undefined;
  billingAddressContactName?: string | undefined;
  billingAddressCountry?: string | undefined;
  billingAddressStreet1?: string | undefined;
  billingAddressStreet2?: string | undefined;
  billingAddressName?: string | undefined;
  billingAddressPostalCode?: string | undefined;
  billingAddressStateOrProvince?: string | undefined;
  billingAddressPhone?: string | undefined;
  closedOn?: Date | undefined;
  contactId?: string | undefined;
  customerId?: string | undefined;
  description?: string | undefined;
  discount?: number | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  totalAmount?: number | undefined;
  termsOfPaymentCode?: string | undefined;
  priceListId?: string | undefined;
  revisionNumber?: number | undefined;
  status?: string | undefined;
  statusReason?: string | undefined;
  netAmount?: number | undefined;
  tax?: number | undefined;
  versionNumber?: number | undefined;
  reasonForRejection?: string | undefined;
  deleteDate?: Date | undefined;
  contact?: OmContact | undefined;
  customer?: OmOrganisation | undefined;
  incidentNavigation?: FmIncident | undefined;
  priceList?: FmPriceList | undefined;
  slaNavigation?: FmSla | undefined;
  fmDocument?: FmDocument[] | undefined;
  fmQuoteDetail?: FmQuoteDetail[] | undefined;
}

export interface FmIncident {
  incidentId?: string | undefined;
  name: string;
  caseOriginCode?: string | undefined;
  caseOriginCodeId?: string | undefined;
  archObjId?: string | undefined;
  techObjId?: string | undefined;
  description?: string | undefined;
  routingTypeId?: string | undefined;
  masterIncidentId?: string | undefined;
  ticketNumber?: string | undefined;
  externalReference?: string | undefined;
  reasonForComplaint?: string | undefined;
  incidentOrigin?: string | undefined;
  incidentOriginId?: string | undefined;
  incidentTypeId?: string | undefined;
  externalResponse?: string | undefined;
  externalCompletion?: Date | undefined;
  additionalInformationOrComments?: string | undefined;
  status?: string | undefined;
  statusId?: string | undefined;
  statusReason?: string | undefined;
  statusReasonId?: string | undefined;
  incidentPriorty?: string | undefined;
  incidentPriorityId?: string | undefined;
  parentIncidentId?: string | undefined;
  changeDate?: Date | undefined;
  costCenterId?: string | undefined;
  incidentClassId?: string | undefined;
  sla?: string | undefined;
  agreementId?: string | undefined;
  setReminder?: boolean | undefined;
  reminderDate?: Date | undefined;
  rentalUnitConnectionId?: string | undefined;
  rentalUnitId?: string | undefined;
  terminatedTo?: Date | undefined;
  recordingRentalDefect?: Date | undefined;
  rentalContractId?: string | undefined;
  acceptanceDate?: Date | undefined;
  terminationReceived?: Date | undefined;
  terminationFrom?: Date | undefined;
  processor?: string | undefined;
  alternateCity?: string | undefined;
  alternatePostalCode?: string | undefined;
  alternateStateProvince?: string | undefined;
  alternateStreet?: string | undefined;
  echeckNecessary?: string | undefined;
  keepBuildingStrategically?: string | undefined;
  preparationNecessary?: string | undefined;
  property?: string | undefined;
  adJoiningProperty?: string | undefined;
  commissionMarketingLight?: string | undefined;
  commonNeeds?: string | undefined;
  companyResidence?: string | undefined;
  separationCosts?: number | undefined;
  preparationTicketAvailable?: string | undefined;
  pricePerSquareMeter?: number | undefined;
  _111costs?: number | undefined;
  setUpCosts?: number | undefined;
  descriptionSetUpCosts?: string | undefined;
  marketingType?: string | undefined;
  rentalContractChecked?: string | undefined;
  separationConcept?: string | undefined;
  lettingDecision?: string | undefined;
  lettingDecisionConfirmation?: string | undefined;
  lettingDecisionConfirmationFromId?: string | undefined;
  interestedPartyCancel?: string | undefined;
  stateOrProvince?: string | undefined;
  plotNumber?: string | undefined;
  deadline?: Date | undefined;
  city?: string | undefined;
  postalCode?: string | undefined;
  miscellaneousIncidentClass?: string | undefined;
  street?: string | undefined;
  powerOfDispositionId?: string | undefined;
  rentalSpace?: number | undefined;
  orderSheetCreate?: string | undefined;
  releaseRentalUnit?: string | undefined;
  releaseRentalUnitFromId?: string | undefined;
  profitable?: string | undefined;
  profitableId?: string | undefined;
  informAboutMarketing?: string | undefined;
  setupCostsRenter?: number | undefined;
  startActivities?: string | undefined;
  initiateRenegotiation?: string | undefined;
  uploadRentalContract?: string | undefined;
  rentalUnitHandedOver?: string | undefined;
  incidentToTender?: string | undefined;
  customerBudgetId?: string | undefined;
  maintask?: string | undefined;
  requestType?: string | undefined;
  requestTypeId?: string | undefined;
  paybackPeriod?: string | undefined;
  organisationId?: string | undefined;
  contactId?: string | undefined;
  primaryContactId?: string | undefined;
  responsibleContactId?: string | undefined;
  interestedpartyId?: string | undefined;
  notifyingContactId?: string | undefined;
  additionalContactId?: string | undefined;
  propertyBrochureId?: string | undefined;
  propertyBrochureAvailabilityId?: string | undefined;
  isRenterChecked?: boolean | undefined;
  internalTicketNumber?: string | undefined;
  createdOn?: Date | undefined;
  rentalContractStartDate?: Date | undefined;
  arrivalDate?: Date | undefined;
  rentalContractEndDate?: Date | undefined;
  contactPreferences?: string | undefined;
  incidentGradingId?: string | undefined;
  deleteDate?: Date | undefined;
  accessPermit?: boolean | undefined;
  estimatedCosts?: number | undefined;
  facilityManagementProcessStatusId?: string | undefined;
  preferredTimeWindowStart?: Date | undefined;
  preferredTimeWindowEnd?: Date | undefined;
  additionalContact?: OmContact | undefined;
  agreement?: FmAgreement | undefined;
  archObj?: DtArchObjHierarchy | undefined;
  caseOriginCodeNavigation?: SysEnum | undefined;
  contact?: OmContact | undefined;
  costCenter?: FiCostCenter | undefined;
  facilityManagementProcessStatus?: SysEnum | undefined;
  incidentClass?: FmIncidentClass | undefined;
  incidentGrading?: FmIncidentGrading | undefined;
  incidentOriginNavigation?: SysEnum | undefined;
  incidentPriority?: SysEnum | undefined;
  incidentType?: FmIncidentType | undefined;
  interestedparty?: OmContact | undefined;
  lettingDecisionConfirmationFrom?: OmSystemUser | undefined;
  masterIncident?: FmIncident | undefined;
  notifyingContact?: OmContact | undefined;
  organisation?: OmOrganisation | undefined;
  parentIncident?: FmIncident | undefined;
  powerOfDisposition?: SysEnum | undefined;
  primaryContact?: OmContact | undefined;
  profitableNavigation?: SysEnum | undefined;
  propertyBrochure?: PmPropertyBrochure | undefined;
  propertyBrochureAvailability?: PmPropertyBrochureAvailability | undefined;
  releaseRentalUnitFrom?: OmSystemUser | undefined;
  releaseRentalUnitNavigation?: OmSystemUser | undefined;
  rentalContract?: PmRentalContract | undefined;
  rentalUnit?: PmRentalUnit | undefined;
  rentalUnitConnection?: PmRentalUnit | undefined;
  requestTypeNavigation?: SysEnum | undefined;
  responsibleContact?: OmContact | undefined;
  routingType?: FmRoutingType | undefined;
  slaNavigation?: FmSla | undefined;
  statusNavigation?: SysEnum | undefined;
  statusReasonNavigation?: SysEnum | undefined;
  techObj?: DtTechObjHierarchy | undefined;
  fmDocument?: FmDocument[] | undefined;
  fmIncidentContactRole?: FmIncidentContactRole[] | undefined;
  fmIncidentOrganisationRole?: FmIncidentOrganisationRole[] | undefined;
  fmQuote?: FmQuote[] | undefined;
  fmTask?: FmTask[] | undefined;
  fmWorkOrder?: FmWorkOrder[] | undefined;
  inverseMasterIncident?: FmIncident[] | undefined;
  inverseParentIncident?: FmIncident[] | undefined;
}

export interface FmAgreement {
  agreementId?: string | undefined;
  agreementNumber?: string | undefined;
  serviceAccount: string;
  billingAccount?: string | undefined;
  description?: string | undefined;
  startDate?: Date;
  endDate?: Date;
  duration?: number;
  originatingAgreement?: string | undefined;
  agreementDetails?: string | undefined;
  agreementRecordGeneration?: Date | undefined;
  taxable?: boolean;
  salesTaxCode?: string | undefined;
  dateCancelled?: Date | undefined;
  deleteDate?: Date | undefined;
  billingAccountNavigation?: OmOrganisation | undefined;
  originatingAgreementNavigation?: FmAgreement | undefined;
  serviceAccountNavigation?: OmOrganisation | undefined;
  fmDocument?: FmDocument[] | undefined;
  fmIncident?: FmIncident[] | undefined;
  fmWorkOrder?: FmWorkOrder[] | undefined;
  inverseOriginatingAgreementNavigation?: FmAgreement[] | undefined;
}

export interface FmWorkOrder {
  workOrderId?: string | undefined;
  name: string;
  workOrderTitle?: string | undefined;
  externalServiceProviderId?: string | undefined;
  primaryIncidentType?: string | undefined;
  maintenanceConfirmation?: string | undefined;
  tender?: string | undefined;
  projectId?: string | undefined;
  isAuthorized?: boolean | undefined;
  authorizedDate?: string | undefined;
  internalExternal?: string | undefined;
  frameworkAgreementId?: string | undefined;
  alternateKey?: string | undefined;
  customerAssetId?: string | undefined;
  createdBy?: string | undefined;
  authorizerId?: string | undefined;
  authorizedBy?: string | undefined;
  changeDate?: Date | undefined;
  incidentId?: string | undefined;
  workOrderType?: string | undefined;
  locationId?: string | undefined;
  orderConfirmation?: string | undefined;
  dateWindowStart?: Date | undefined;
  dateWindowEnd?: Date | undefined;
  serviceAccountId?: string | undefined;
  firstArrivedAt?: Date | undefined;
  externalReference?: string | undefined;
  totalAmount?: number | undefined;
  primaryIncidentEstimatedDuration?: number | undefined;
  totalEstimatedDuration?: number | undefined;
  estimatedSubtotalAmount?: number | undefined;
  parentWorkOrderId?: string | undefined;
  agreementId?: string | undefined;
  transactionCurrency?: string | undefined;
  timeToPromised?: Date | undefined;
  timeFromPromised?: Date | undefined;
  timeWindowStart?: Date | undefined;
  timeWindowEnd?: Date | undefined;
  subTotalAmount?: number | undefined;
  systemstatus?: string | undefined;
  substatus?: string | undefined;
  workOrderSummary?: string | undefined;
  completedAt?: Date | undefined;
  billingAccountId?: string | undefined;
  timeClosed?: Date | undefined;
  workLocation?: string | undefined;
  priceListId?: string | undefined;
  primaryIncidentDescription?: string | undefined;
  bookingSummary?: string | undefined;
  city?: string | undefined;
  postalCode?: string | undefined;
  street?: string | undefined;
  houseNumber?: string | undefined;
  district?: string | undefined;
  orderType?: string | undefined;
  bookableRessourceId?: string | undefined;
  organisationalUnitId?: string | undefined;
  reporterId?: string | undefined;
  createdOn?: Date | undefined;
  deleteDate?: Date | undefined;
  accessPermit?: boolean | undefined;
  tenantWasPresent?: boolean | undefined;
  reportedByContactId?: string | undefined;
  contactOnSiteId?: string | undefined;
  bookingStart?: Date | undefined;
  bookingEnd?: Date | undefined;
  feedback?: string | undefined;
  feedbackFollowUpJob?: string | undefined;
  title?: string | undefined;
  eventMatchCode?: string | undefined;
  productionId?: string | undefined;
  internalOffer?: string | undefined;
  notes?: string | undefined;
  totalCostSum?: number | undefined;
  rejectionReason?: string | undefined;
  agreement?: FmAgreement | undefined;
  authorizedByNavigation?: OmSystemUser | undefined;
  authorizer?: OmSystemUser | undefined;
  billingAccount?: OmOrganisation | undefined;
  bookableRessource?: FmBookableRessource | undefined;
  contactOnSite?: OmContact | undefined;
  createdByNavigation?: OmSystemUser | undefined;
  customerAsset?: DtTechObjHierarchy | undefined;
  externalServiceProvider?: OmOrganisation | undefined;
  frameworkAgreement?: FmFrameworkAgreement | undefined;
  incident?: FmIncident | undefined;
  location?: DtArchObjHierarchy | undefined;
  organisationalUnit?: OmOrganisationalUnit | undefined;
  parentWorkOrder?: FmWorkOrder | undefined;
  priceList?: FmPriceList | undefined;
  primaryIncidentTypeNavigation?: FmIncidentType | undefined;
  production?: Production | undefined;
  project?: FmProject | undefined;
  reportedByContact?: OmContact | undefined;
  reporter?: OmContact | undefined;
  serviceAccount?: OmOrganisation | undefined;
  workOrderTypeNavigation?: FmWorkOrderType | undefined;
  complaint?: Complaint[] | undefined;
  fmDocument?: FmDocument[] | undefined;
  fmOrderInquiry?: FmOrderInquiry[] | undefined;
  fmWorkOrderMilestone?: FmWorkOrderMilestone[] | undefined;
  fmWorkOrderProduct?: FmWorkOrderProduct[] | undefined;
  fmWorkOrderService?: FmWorkOrderService[] | undefined;
  fmWorkOrderServiceTask?: FmWorkOrderServiceTask[] | undefined;
  inverseParentWorkOrder?: FmWorkOrder[] | undefined;
  workOrderPosition?: WorkOrderPosition[] | undefined;
  workOrderPreconditionPredecessorWorkOrder?: WorkOrderPrecondition[] | undefined;
  workOrderPreconditionWorkOrder?: WorkOrderPrecondition[] | undefined;
}

export interface OmSystemUser {
  systemUserId?: string | undefined;
  domainName?: string | undefined;
  firstName?: string | undefined;
  lastName: string;
  title?: string | undefined;
  email?: string | undefined;
  mobile?: string | undefined;
  phone?: string | undefined;
  siteId?: string | undefined;
  territoryId?: string | undefined;
  businessUnitId?: string | undefined;
  deleteDate?: Date | undefined;
  serviceProviderAccountId?: string | undefined;
  responsible?: string | undefined;
  site?: DtSite | undefined;
  fmBookableRessource?: FmBookableRessource[] | undefined;
  fmIncidentLettingDecisionConfirmationFrom?: FmIncident[] | undefined;
  fmIncidentReleaseRentalUnitFrom?: FmIncident[] | undefined;
  fmIncidentReleaseRentalUnitNavigation?: FmIncident[] | undefined;
  fmWorkOrderAuthorizedByNavigation?: FmWorkOrder[] | undefined;
  fmWorkOrderAuthorizer?: FmWorkOrder[] | undefined;
  fmWorkOrderCreatedByNavigation?: FmWorkOrder[] | undefined;
  pmRentalContractFirstSignee?: PmRentalContract[] | undefined;
  pmRentalContractOwner?: PmRentalContract[] | undefined;
  pmRentalContractSecondSignee?: PmRentalContract[] | undefined;
  workOrderPosition?: WorkOrderPosition[] | undefined;
  workOrderPositionHall?: WorkOrderPositionHall[] | undefined;
}

export interface DtSite {
  name: string;
  siteId?: string | undefined;
  type?: string | undefined;
  siteCode?: string | undefined;
  validUntil?: Date | undefined;
  validFrom?: Date | undefined;
  changeDate?: Date | undefined;
  name2?: string | undefined;
  name3?: string | undefined;
  deleteDate?: Date | undefined;
  levelId?: string | undefined;
  bookable?: boolean | undefined;
  hallPlan?: string | undefined;
  roomGroup?: string | undefined;
  technicalDescription?: string | undefined;
  technicalDescriptionEn?: string | undefined;
  amountPersons?: number | undefined;
  number?: string | undefined;
  length?: number | undefined;
  width?: number | undefined;
  usingArea?: number | undefined;
  diameter?: number | undefined;
  clearHeight1?: number | undefined;
  clearHeight2?: number | undefined;
  soilTypeId?: string | undefined;
  utilityFloorOnSolidBase?: boolean | undefined;
  solidFloorWithCableDucts?: boolean | undefined;
  permissibleFloorLoad?: number | undefined;
  wheelLoad?: number | undefined;
  subceiling?: boolean | undefined;
  legend?: string | undefined;
  suspensionPointsId?: string | undefined;
  windowsId?: string | undefined;
  numberGates?: number | undefined;
  gateways?: string | undefined;
  gasConnection?: boolean | undefined;
  cooling?: boolean | undefined;
  waterConnection?: number | undefined;
  waterDischarge?: boolean | undefined;
  fireProtection?: boolean | undefined;
  pillars?: boolean | undefined;
  freightElevators?: boolean | undefined;
  comment?: string | undefined;
  capacity?: number | undefined;
  technicalCoding?: string | undefined;
  din277Id?: string | undefined;
  areaRoomGroup?: number | undefined;
  areaDin277Flo?: number | undefined;
  areaHnf?: number | undefined;
  areaNnf?: number | undefined;
  areaVf?: number | undefined;
  areaFf?: number | undefined;
  installationId?: string | undefined;
  vpsz?: string | undefined;
  din277?: SysEnum | undefined;
  level?: SysEnum | undefined;
  site?: DtArchObjHierarchy | undefined;
  soilType?: SysEnum | undefined;
  suspensionPoints?: SysEnum | undefined;
  windows?: SysEnum | undefined;
  omSystemUser?: OmSystemUser[] | undefined;
}

export interface DtArchObjHierarchy {
  archObjId?: string | undefined;
  parentArchObjId?: string | undefined;
  archObjType: string;
  changeDate?: Date | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  measurementGroupId?: string | undefined;
  departmentId?: string | undefined;
  deleteDate?: Date | undefined;
  sapIntreno?: string | undefined;
  alternateKey1?: string | undefined;
  alternateKey2?: string | undefined;
  alternateKey3?: string | undefined;
  department?: OmDepartment | undefined;
  measurementGroup?: DtMeasurementGroup | undefined;
  parentArchObj?: DtArchObjHierarchy | undefined;
  dtBuilding?: DtBuilding | undefined;
  dtDistrict?: DtDistrict | undefined;
  dtFloor?: DtFloor | undefined;
  dtLand?: DtLand | undefined;
  dtSite?: DtSite | undefined;
  dtSpace?: DtSpace | undefined;
  dtSubSpace?: DtSubSpace | undefined;
  dtWorkspace?: DtWorkspace | undefined;
  bookedHall?: BookedHall[] | undefined;
  dtArchObjAddress?: DtArchObjAddress[] | undefined;
  dtArchObjInformation?: DtArchObjInformation[] | undefined;
  dtArchObjMeasurement?: DtArchObjMeasurement[] | undefined;
  dtArchObjNews?: DtArchObjNews[] | undefined;
  dtArchObjTechObj?: DtArchObjTechObj[] | undefined;
  fmDocument?: FmDocument[] | undefined;
  fmIncident?: FmIncident[] | undefined;
  fmOrderInquiry?: FmOrderInquiry[] | undefined;
  fmWorkOrder?: FmWorkOrder[] | undefined;
  inverseParentArchObj?: DtArchObjHierarchy[] | undefined;
  omContactArchObjRole?: OmContactArchObjRole[] | undefined;
  omContactAuthorization?: OmContactAuthorization[] | undefined;
  omOrganisationArchObjRole?: OmOrganisationArchObjRole[] | undefined;
  pmRentalContract?: PmRentalContract[] | undefined;
  pmRentalContractArchObj?: PmRentalContractArchObj[] | undefined;
  pmRentalUnit?: PmRentalUnit[] | undefined;
  pmRentalUnitArchObj?: PmRentalUnitArchObj[] | undefined;
  rentalContractSpaceBuildingArchObj?: RentalContractSpace[] | undefined;
  rentalContractSpaceEconomicUnitArchObj?: RentalContractSpace[] | undefined;
  rentalContractSpaceLandArchObj?: RentalContractSpace[] | undefined;
  rentalContractSpaceSpaceArchObj?: RentalContractSpace[] | undefined;
}

export interface OmDepartment {
  departmentId?: string | undefined;
  name: string;
  description?: string | undefined;
  deleteDate?: Date | undefined;
  dtArchObjHierarchy?: DtArchObjHierarchy[] | undefined;
}

export interface DtMeasurementGroup {
  measurementGroupId?: string | undefined;
  name?: string | undefined;
  type?: string | undefined;
  changeDate?: Date | undefined;
  description?: string | undefined;
  shortName: string;
  source?: string | undefined;
  parentMeasurementGroupId?: string | undefined;
  objectType?: string | undefined;
  deleteDate?: Date | undefined;
  dtArchObjHierarchy?: DtArchObjHierarchy[] | undefined;
  dtMeasurement?: DtMeasurement[] | undefined;
  dtTechObjHierarchy?: DtTechObjHierarchy[] | undefined;
}

export interface DtMeasurement {
  measurementId?: string | undefined;
  measurementGroupId?: string | undefined;
  name?: string | undefined;
  defaultUnit?: string | undefined;
  isSumValue?: boolean;
  shortName?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  measurementGroup?: DtMeasurementGroup | undefined;
  dtArchObjMeasurement?: DtArchObjMeasurement[] | undefined;
  dtMeasurementValue?: DtMeasurementValue[] | undefined;
  dtTechObjMeasurement?: DtTechObjMeasurement[] | undefined;
}

export interface DtArchObjMeasurement {
  archObjId?: string | undefined;
  measurementId?: string | undefined;
  value?: number | undefined;
  intValue?: number | undefined;
  floatValue?: number | undefined;
  charValue?: string | undefined;
  dateValue?: Date | undefined;
  bitValue?: boolean | undefined;
  selectedValue?: string | undefined;
  unit?: string | undefined;
  validFrom?: Date;
  changeDate?: Date | undefined;
  validUntil?: Date | undefined;
  isHierarchical?: boolean | undefined;
  deleteDate?: Date | undefined;
  archObj?: DtArchObjHierarchy | undefined;
  measurement?: DtMeasurement | undefined;
  selectedValueNavigation?: DtMeasurementValue | undefined;
}

export interface DtMeasurementValue {
  measurementValueId?: string | undefined;
  measurementId: string;
  numValue?: number | undefined;
  intValue?: number | undefined;
  floatValue?: number | undefined;
  charValue?: string | undefined;
  dateValue?: Date | undefined;
  bitValue?: boolean | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  measurement?: DtMeasurement | undefined;
  dtArchObjMeasurement?: DtArchObjMeasurement[] | undefined;
  dtTechObjMeasurement?: DtTechObjMeasurement[] | undefined;
}

export interface DtTechObjMeasurement {
  techObjId?: string | undefined;
  measurementId?: string | undefined;
  value?: number | undefined;
  intValue?: number | undefined;
  floatValue?: number | undefined;
  charValue?: string | undefined;
  dateValue?: Date | undefined;
  bitValue?: boolean | undefined;
  selectedValue?: string | undefined;
  unit?: string | undefined;
  validFrom?: Date;
  changeDate?: Date | undefined;
  validUntil?: Date | undefined;
  isHierarchical?: boolean | undefined;
  deleteDate?: Date | undefined;
  measurement?: DtMeasurement | undefined;
  selectedValueNavigation?: DtMeasurementValue | undefined;
  techObj?: DtTechObjHierarchy | undefined;
}

export interface DtTechObjHierarchy {
  techObjId?: string | undefined;
  parentTechObjId?: string | undefined;
  changeDate?: Date | undefined;
  constructionYear?: Date | undefined;
  serialNumber?: string | undefined;
  manufacturer?: string | undefined;
  barcode?: string | undefined;
  warrantyEndDate?: Date | undefined;
  organisationId?: string | undefined;
  techObjTypeId?: string | undefined;
  name?: string | undefined;
  uniqueName?: string | undefined;
  measurementGroupId?: string | undefined;
  deleteDate?: Date | undefined;
  measurementGroup?: DtMeasurementGroup | undefined;
  parentTechObj?: DtTechObjHierarchy | undefined;
  techObjType?: DtTechObjType | undefined;
  dtMeasuringPoint?: DtMeasuringPoint | undefined;
  dtSystem?: DtSystem | undefined;
  dtArchObjTechObj?: DtArchObjTechObj[] | undefined;
  dtTechObjAddress?: DtTechObjAddress[] | undefined;
  dtTechObjMeasurement?: DtTechObjMeasurement[] | undefined;
  fmIncident?: FmIncident[] | undefined;
  fmWorkOrder?: FmWorkOrder[] | undefined;
  inverseParentTechObj?: DtTechObjHierarchy[] | undefined;
}

export interface DtTechObjType {
  techObjTypeId?: string | undefined;
  parentTechObjTypeId?: string | undefined;
  name?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  dtTechObjHierarchy?: DtTechObjHierarchy[] | undefined;
}

export interface DtMeasuringPoint {
  id?: string | undefined;
  name: string;
  type?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  unit?: string | undefined;
  idNavigation?: DtTechObjHierarchy | undefined;
  dtMeasurementReading?: DtMeasurementReading[] | undefined;
}

export interface DtMeasurementReading {
  id?: string | undefined;
  measuringPointId: string;
  value?: number | undefined;
  charValue?: string | undefined;
  measurementTimestamp?: Date | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  measuringPoint?: DtMeasuringPoint | undefined;
}

export interface DtSystem {
  systemId?: string | undefined;
  name: string;
  class?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  system?: DtTechObjHierarchy | undefined;
}

export interface DtArchObjTechObj {
  archObjId?: string | undefined;
  techObjId?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  archObj?: DtArchObjHierarchy | undefined;
  techObj?: DtTechObjHierarchy | undefined;
}

export interface DtTechObjAddress {
  techObjId?: string | undefined;
  addressId?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  address?: OmAddress | undefined;
  techObj?: DtTechObjHierarchy | undefined;
}

export interface OmAddress {
  addressId?: string | undefined;
  name?: string | undefined;
  type?: string | undefined;
  streetName?: string | undefined;
  houseNumber?: string | undefined;
  additionalInformation?: string | undefined;
  apartmentNumber?: string | undefined;
  district?: string | undefined;
  city: string;
  state?: string | undefined;
  country?: string | undefined;
  postalCode?: string | undefined;
  longitude?: number | undefined;
  latitude?: number | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  dtArchObjAddress?: DtArchObjAddress[] | undefined;
  dtParcelAddress?: DtParcelAddress[] | undefined;
  dtTechObjAddress?: DtTechObjAddress[] | undefined;
  omContactAddress?: OmContactAddress[] | undefined;
  omOrganisationAddress?: OmOrganisationAddress[] | undefined;
}

export interface DtArchObjAddress {
  archObjId?: string | undefined;
  addressId?: string | undefined;
  changeDate?: Date | undefined;
  validFrom?: Date;
  validUnitl?: Date | undefined;
  smartUsKey?: string | undefined;
  addressType?: string | undefined;
  deleteDate?: Date | undefined;
  address?: OmAddress | undefined;
  archObj?: DtArchObjHierarchy | undefined;
}

export interface DtParcelAddress {
  parcelId?: string | undefined;
  addressId?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  address?: OmAddress | undefined;
  parcel?: DtParcel | undefined;
}

export interface DtParcel {
  parcelId?: string | undefined;
  name: string;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  dtParcelAddress?: DtParcelAddress[] | undefined;
}

export interface OmContactAddress {
  contactId?: string | undefined;
  addressId?: string | undefined;
  changeDate?: Date | undefined;
  validFrom?: Date;
  validUnitl?: Date | undefined;
  smartUsKey?: string | undefined;
  addressType?: string | undefined;
  deleteDate?: Date | undefined;
  address?: OmAddress | undefined;
  contact?: OmContact | undefined;
}

export interface OmOrganisationAddress {
  organisationId?: string | undefined;
  addressId?: string | undefined;
  changeDate?: Date | undefined;
  validFrom?: Date;
  validUnitl?: Date | undefined;
  smartUsKey?: string | undefined;
  addressType?: string | undefined;
  deleteDate?: Date | undefined;
  address?: OmAddress | undefined;
  organisation?: OmOrganisation | undefined;
}

export interface DtBuilding {
  buildingId?: string | undefined;
  name?: string | undefined;
  buildingCode?: string | undefined;
  primaryTypeOfBuilding?: string | undefined;
  secondaryTypeOfBuilding?: string | undefined;
  energyEfficiencyClass?: string | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  constructionYear?: Date | undefined;
  yearOfLastRefurbisment?: Date | undefined;
  monumentProtection?: boolean | undefined;
  typeOfOwnership?: string | undefined;
  selfUse?: boolean | undefined;
  tenantStructure?: string | undefined;
  parkingSpaces?: number | undefined;
  primaryEnergyType?: string | undefined;
  primaryWaterType?: string | undefined;
  primaryHeatingType?: string | undefined;
  secondaryHeatingType?: string | undefined;
  airConditioning?: boolean | undefined;
  changeDate?: Date | undefined;
  imk?: string | undefined;
  name2?: string | undefined;
  name3?: string | undefined;
  deleteDate?: Date | undefined;
  building?: DtArchObjHierarchy | undefined;
}

export interface DtDistrict {
  districtId?: string | undefined;
  name: string;
  changeDate?: Date | undefined;
  type: string;
  alternateKey?: string | undefined;
  name2?: string | undefined;
  name3?: string | undefined;
  deleteDate?: Date | undefined;
  district?: DtArchObjHierarchy | undefined;
}

export interface DtFloor {
  floorId?: string | undefined;
  name: string;
  floorCode?: string | undefined;
  floorNumber?: number | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  changeDate?: Date | undefined;
  name2?: string | undefined;
  name3?: string | undefined;
  deleteDate?: Date | undefined;
  floor?: DtArchObjHierarchy | undefined;
}

export interface DtLand {
  landId?: string | undefined;
  name: string;
  landCode?: number | undefined;
  type?: string | undefined;
  landCoverage?: string | undefined;
  landParcelNr?: number | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  servitudeId?: string | undefined;
  georefId?: string | undefined;
  changeDate?: Date | undefined;
  name2?: string | undefined;
  name3?: string | undefined;
  typeOfOwnership?: string | undefined;
  deleteDate?: Date | undefined;
  land?: DtArchObjHierarchy | undefined;
}

export interface DtSpace {
  name?: string | undefined;
  spaceCode?: string | undefined;
  spaceNumber?: number | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  spaceId?: string | undefined;
  spaceHeightUsable?: number | undefined;
  spaceHeight?: number | undefined;
  spaceVolumeGross?: number | undefined;
  spaceVolumeNet?: number | undefined;
  primaryFloorMaterial?: string | undefined;
  primaryCeilingMaterial?: string | undefined;
  rentability?: boolean | undefined;
  effectZonesHeating?: number | undefined;
  effectZonesCooling?: number | undefined;
  effectZonesVentiliation?: number | undefined;
  climateHeated?: boolean | undefined;
  climateCooled?: boolean | undefined;
  coUseArea?: boolean | undefined;
  maximumOccupancy?: number | undefined;
  ventilationType?: string | undefined;
  changeDate?: Date | undefined;
  spaceTypeId?: string | undefined;
  name2?: string | undefined;
  name3?: string | undefined;
  deleteDate?: Date | undefined;
  typeOfUse?: string | undefined;
  detailAreaType?: string | undefined;
  space?: DtArchObjHierarchy | undefined;
  spaceType?: DtSpaceType | undefined;
}

export interface DtSpaceType {
  spaceTypeId?: string | undefined;
  name?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  source?: string | undefined;
  classification?: string | undefined;
  dtSpace?: DtSpace[] | undefined;
}

export interface DtSubSpace {
  subSpaceId?: string | undefined;
  name?: string | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  changeDate?: Date | undefined;
  name2?: string | undefined;
  name3?: string | undefined;
  deleteDate?: Date | undefined;
  number?: number | undefined;
  status?: string | undefined;
  subSpace?: DtArchObjHierarchy | undefined;
}

export interface DtWorkspace {
  workspaceId?: string | undefined;
  name?: string | undefined;
  validFrom?: Date;
  validUntil?: Date;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  workspace?: DtArchObjHierarchy | undefined;
}

export interface DtArchObjInformation {
  id?: string | undefined;
  archObjId?: string | undefined;
  text?: string | undefined;
  infoCategoryId?: string | undefined;
  isPublished?: boolean | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  archObj?: DtArchObjHierarchy | undefined;
}

export interface DtArchObjNews {
  id?: string | undefined;
  archObjId?: string | undefined;
  text?: string | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  isPublished?: boolean | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  archObj?: DtArchObjHierarchy | undefined;
}

export interface FmOrderInquiry {
  orderInquiryId?: string | undefined;
  name: string;
  orderId?: string | undefined;
  submitOrderRequest?: string | undefined;
  type?: string | undefined;
  workOrderId?: string | undefined;
  changeDate?: Date | undefined;
  validity?: Date | undefined;
  totalOfferPossible?: boolean | undefined;
  totalOfferPrice?: number | undefined;
  acceptOrderInquiry?: boolean | undefined;
  orderInquiryActiveInPortal?: boolean | undefined;
  description?: string | undefined;
  purchaseProjectId?: string | undefined;
  serviceCompanyId?: string | undefined;
  frameworkAgreementId?: string | undefined;
  initialOfferReceived?: boolean | undefined;
  functionalLocationId?: string | undefined;
  comments?: string | undefined;
  offerValidUntil?: Date | undefined;
  externalOfferId?: string | undefined;
  responsibleContactId?: string | undefined;
  deviatingContactName?: string | undefined;
  deviatingContactEmail?: string | undefined;
  deviatingContactTelephone?: string | undefined;
  earliestStartDate?: Date | undefined;
  latestEndDate?: Date | undefined;
  status?: string | undefined;
  statusReason?: string | undefined;
  deleteDate?: Date | undefined;
  frameworkAgreement?: FmFrameworkAgreement | undefined;
  functionalLocation?: DtArchObjHierarchy | undefined;
  order?: FmPurchaseOrder | undefined;
  purchaseProject?: FmProject | undefined;
  responsibleContact?: OmContact | undefined;
  serviceCompany?: OmOrganisation | undefined;
  workOrder?: FmWorkOrder | undefined;
  fmOrderInquiryPosition?: FmOrderInquiryPosition[] | undefined;
  fmPurchaseOrder?: FmPurchaseOrder[] | undefined;
}

export interface FmFrameworkAgreement {
  frameworkAgreementId?: string | undefined;
  name: string;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  fmDocument?: FmDocument[] | undefined;
  fmOrderInquiry?: FmOrderInquiry[] | undefined;
  fmWorkOrder?: FmWorkOrder[] | undefined;
}

export interface FmPurchaseOrder {
  purchaseOrderId?: string | undefined;
  gu: string;
  template: string;
  budgetType?: string | undefined;
  priorityCodeNemo: string;
  auxillaryAssignment: string;
  functionalLocation: string;
  name: string;
  estimatedBudget?: number;
  purchaseOrderType: string;
  alternateKey?: string | undefined;
  sendPurchaseOrder?: boolean;
  orderInquiry?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  orderInquiryNavigation?: FmOrderInquiry | undefined;
  fmDocument?: FmDocument[] | undefined;
  fmOrderInquiry?: FmOrderInquiry[] | undefined;
}

export interface FmProject {
  projectId?: string | undefined;
  name?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  fmOrderInquiry?: FmOrderInquiry[] | undefined;
  fmProjectMilestone?: FmProjectMilestone[] | undefined;
  fmWorkOrder?: FmWorkOrder[] | undefined;
}

export interface FmProjectMilestone {
  projectId?: string | undefined;
  milestoneNo?: number;
  fixedDate?: Date | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  project?: FmProject | undefined;
}

export interface FmOrderInquiryPosition {
  orderInquiryPositionId?: string | undefined;
  name: string;
  description?: string | undefined;
  comments?: string | undefined;
  noOffer?: boolean | undefined;
  price?: number | undefined;
  orderInquiryId: string;
  amount?: number | undefined;
  unit?: string | undefined;
  materialProductService?: string | undefined;
  changeDate?: Date | undefined;
  status?: string | undefined;
  statusReason?: string | undefined;
  linePosition?: number | undefined;
  deleteDate?: Date | undefined;
  orderInquiry?: FmOrderInquiry | undefined;
  fmQuoteDetail?: FmQuoteDetail[] | undefined;
}

export interface FmQuoteDetail {
  quoteDetailId?: string | undefined;
  name: string;
  quoteId?: string | undefined;
  orderInquiryPositionId?: string | undefined;
  isProductOverridden?: boolean | undefined;
  unitId?: string | undefined;
  productId?: string | undefined;
  productDescription?: string | undefined;
  isPriceOverridden?: boolean | undefined;
  pricePerUnit?: number | undefined;
  volumeDiscount?: number | undefined;
  quantity?: number | undefined;
  baseAmount?: number | undefined;
  manualDiscount?: number | undefined;
  tax?: number | undefined;
  totalAmount?: number | undefined;
  posNo?: number | undefined;
  deleteDate?: Date | undefined;
  orderInquiryPosition?: FmOrderInquiryPosition | undefined;
  quote?: FmQuote | undefined;
  unit?: FmUnit | undefined;
}

export interface FmUnit {
  unitId?: string | undefined;
  name?: string | undefined;
  quantity?: number | undefined;
  baseUnitId?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  baseUnit?: FmUnit | undefined;
  fmProduct?: FmProduct[] | undefined;
  fmQuoteDetail?: FmQuoteDetail[] | undefined;
  fmWorkOrderProduct?: FmWorkOrderProduct[] | undefined;
  fmWorkOrderService?: FmWorkOrderService[] | undefined;
  inverseBaseUnit?: FmUnit[] | undefined;
}

export interface FmWorkOrderProduct {
  id?: string | undefined;
  name: string;
  estimatedQuantity?: number | undefined;
  unitId: string;
  estimatedTotalAmount?: number | undefined;
  productId: string;
  workOrderId: string;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  product?: FmProduct | undefined;
  unit?: FmUnit | undefined;
  workOrder?: FmWorkOrder | undefined;
}

export interface FmWorkOrderService {
  id?: string | undefined;
  name: string;
  estimatedDurationMinutes?: number | undefined;
  unitId: string;
  estimatedTotalAmount?: number | undefined;
  serviceId: string;
  workOrderId: string;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  service?: FmProduct | undefined;
  unit?: FmUnit | undefined;
  workOrder?: FmWorkOrder | undefined;
}

export interface OmContactArchObjRole {
  contactId?: string | undefined;
  archObjId?: string | undefined;
  roleId?: string | undefined;
  validFrom?: Date;
  validUntil?: Date | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  archObj?: DtArchObjHierarchy | undefined;
  contact?: OmContact | undefined;
  role?: OmRole | undefined;
}

export interface OmRole {
  roleId?: string | undefined;
  name?: string | undefined;
  validFrom?: Date;
  validUntil?: Date;
  changeDate?: Date | undefined;
  description?: string | undefined;
  category?: string | undefined;
  deleteDate?: Date | undefined;
  fmIncidentContactRole?: FmIncidentContactRole[] | undefined;
  fmIncidentOrganisationRole?: FmIncidentOrganisationRole[] | undefined;
  omContactArchObjRole?: OmContactArchObjRole[] | undefined;
  omContactRole?: OmContactRole[] | undefined;
  omOrganisationArchObjRole?: OmOrganisationArchObjRole[] | undefined;
  omOrganisationRole?: OmOrganisationRole[] | undefined;
  pmRentalContractContactRole?: PmRentalContractContactRole[] | undefined;
  pmRentalContractOrganisationRole?: PmRentalContractOrganisationRole[] | undefined;
}

export interface FmIncidentContactRole {
  incidentId?: string | undefined;
  contactId?: string | undefined;
  roleId?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  contact?: OmContact | undefined;
  incident?: FmIncident | undefined;
  role?: OmRole | undefined;
}

export interface FmIncidentOrganisationRole {
  incidentId?: string | undefined;
  organisationId?: string | undefined;
  roleId?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  incident?: FmIncident | undefined;
  organisation?: OmOrganisation | undefined;
  role?: OmRole | undefined;
}

export interface OmContactRole {
  contactId?: string | undefined;
  roleId?: string | undefined;
  validFrom?: Date;
  validUntil?: Date | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  contact?: OmContact | undefined;
  role?: OmRole | undefined;
}

export interface OmOrganisationArchObjRole {
  organisationId?: string | undefined;
  archObjId?: string | undefined;
  roleId?: string | undefined;
  validFrom?: Date;
  validUntil?: Date | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  archObj?: DtArchObjHierarchy | undefined;
  organisation?: OmOrganisation | undefined;
  role?: OmRole | undefined;
}

export interface OmOrganisationRole {
  organisationId?: string | undefined;
  roleId?: string | undefined;
  validFrom?: Date;
  validUntil?: Date | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  organisation?: OmOrganisation | undefined;
  role?: OmRole | undefined;
}

export interface PmRentalContractContactRole {
  rentalContractId: string;
  contactId: string;
  roleId: string;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  changeDate?: Date | undefined;
  rentalContractContactRoleId?: string | undefined;
  deleteDate?: Date | undefined;
  contact?: OmContact | undefined;
  rentalContract?: PmRentalContract | undefined;
  role?: OmRole | undefined;
}

export interface PmRentalContract {
  rentalContractId?: string | undefined;
  mainContractId?: string | undefined;
  contractCode?: string | undefined;
  contractType?: string | undefined;
  companyCode?: string | undefined;
  contractName?: string | undefined;
  contractGroup?: string | undefined;
  rentBeginDate?: Date | undefined;
  rentEndDate?: Date | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  periodOfNotice?: string | undefined;
  paymentInAdvance?: boolean | undefined;
  paymentPeriod?: string | undefined;
  shortTermLease?: boolean | undefined;
  tenantSector?: string | undefined;
  turnoverReportingInterval?: string | undefined;
  contractNumber?: string | undefined;
  changeDate?: Date | undefined;
  contractActivation?: Date | undefined;
  contractCurrency?: string | undefined;
  dateContractSigned?: Date | undefined;
  dateContractSecondSignature?: Date | undefined;
  dateReceiptOfNotice?: Date | undefined;
  reasonForTermination?: string | undefined;
  dateTerminationContract?: Date | undefined;
  contactId?: string | undefined;
  renterContactId?: string | undefined;
  accountId?: string | undefined;
  rentalSecurtiyCharacteristic?: boolean | undefined;
  depositAmount?: string | undefined;
  archObjId?: string | undefined;
  createdBy?: string | undefined;
  responsiblePerson?: string | undefined;
  firstContractEnddate?: Date | undefined;
  ownerId?: string | undefined;
  contractCategory?: string | undefined;
  firstSigneeId?: string | undefined;
  secondSigneeId?: string | undefined;
  signatureStatus?: string | undefined;
  helloSignEmailSubject?: string | undefined;
  helloSignEmailBody?: string | undefined;
  helloSignDocumentId?: string | undefined;
  stateHba?: string | undefined;
  maximumExtension?: Date | undefined;
  nextEndOfContract?: Date | undefined;
  possibleOwnTermination?: Date | undefined;
  possibleTerminationPartner?: Date | undefined;
  monthsOptionPeriod?: number | undefined;
  monthsTerminationPeriod?: number | undefined;
  deleteDate?: Date | undefined;
  archObj?: DtArchObjHierarchy | undefined;
  contractTypeNavigation?: PmRentalContractType | undefined;
  firstSignee?: OmSystemUser | undefined;
  helloSignDocument?: FmDocument | undefined;
  owner?: OmSystemUser | undefined;
  renterContact?: OmContact | undefined;
  secondSignee?: OmSystemUser | undefined;
  fmDocument?: FmDocument[] | undefined;
  fmIncident?: FmIncident[] | undefined;
  pmRentalCondition?: PmRentalCondition[] | undefined;
  pmRentalContractArchObj?: PmRentalContractArchObj[] | undefined;
  pmRentalContractContactRole?: PmRentalContractContactRole[] | undefined;
  pmRentalContractOrganisationRole?: PmRentalContractOrganisationRole[] | undefined;
  pmRentalContractRentalUnit?: PmRentalContractRentalUnit[] | undefined;
  rentalContractSpace?: RentalContractSpace[] | undefined;
}

export interface PmRentalContractType {
  rentalContractTypeId?: string | undefined;
  name?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  pmRentalContract?: PmRentalContract[] | undefined;
}

export interface PmRentalCondition {
  rentalConditionId?: string | undefined;
  transactionCurrencyId?: string | undefined;
  firstBookingFrom?: Date | undefined;
  rentalConditionType?: string | undefined;
  price?: number | undefined;
  rentalContract?: string | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  changeDate?: Date | undefined;
  uniqueCondition?: boolean | undefined;
  calculationRuleParameterOne?: string | undefined;
  calculationRuleParameterTwo?: string | undefined;
  deleteIndicator?: boolean | undefined;
  deleteDate?: Date | undefined;
  rentalConditionTypeNavigation?: PmRentalConditionType | undefined;
  rentalContractNavigation?: PmRentalContract | undefined;
}

export interface PmRentalConditionType {
  rentalConditionTypeId?: string | undefined;
  name?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  pmRentalCondition?: PmRentalCondition[] | undefined;
}

export interface PmRentalContractArchObj {
  rentalContractId?: string | undefined;
  archObjId?: string | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  typeOfAssignment?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  archObj?: DtArchObjHierarchy | undefined;
  rentalContract?: PmRentalContract | undefined;
}

export interface PmRentalContractOrganisationRole {
  rentalContractId: string;
  organisationId: string;
  roleId: string;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  changeDate?: Date | undefined;
  rentalContractOrgRoleId?: string | undefined;
  deleteDate?: Date | undefined;
  organisation?: OmOrganisation | undefined;
  rentalContract?: PmRentalContract | undefined;
  role?: OmRole | undefined;
}

export interface PmRentalContractRentalUnit {
  rentalContractId?: string | undefined;
  rentalUnitId?: string | undefined;
  validFrom?: Date;
  validUnitl?: Date | undefined;
  typeOfRentalUnitAssignment?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  rentalContract?: PmRentalContract | undefined;
  rentalUnit?: PmRentalUnit | undefined;
}

export interface PmRentalUnit {
  rentalUnitId?: string | undefined;
  name?: string | undefined;
  rentalUnitCode?: string | undefined;
  rentedOut?: boolean | undefined;
  usageType?: string | undefined;
  vacancy?: boolean | undefined;
  usageGroup?: string | undefined;
  vacancySince?: Date | undefined;
  rentalSpace?: number | undefined;
  createdFromPtb?: string | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  economicUnitNumber?: string | undefined;
  cashFlowGenerationFrom?: Date | undefined;
  type?: string | undefined;
  changeDate?: Date | undefined;
  siteId?: string | undefined;
  deleteDate?: Date | undefined;
  site?: DtArchObjHierarchy | undefined;
  fmIncidentRentalUnit?: FmIncident[] | undefined;
  fmIncidentRentalUnitConnection?: FmIncident[] | undefined;
  pmPropertyBrochure?: PmPropertyBrochure[] | undefined;
  pmRentalContractRentalUnit?: PmRentalContractRentalUnit[] | undefined;
  pmRentalUnitArchObj?: PmRentalUnitArchObj[] | undefined;
}

export interface PmPropertyBrochure {
  propertyBrochureId?: string | undefined;
  name: string;
  propertyDescription?: string | undefined;
  locationDescription?: string | undefined;
  nameEn?: string | undefined;
  propertyDescriptionEn?: string | undefined;
  locationDescriptionEn?: string | undefined;
  noOfRooms?: number | undefined;
  basicRent?: number | undefined;
  ancillaryCosts?: number | undefined;
  totalRent?: number | undefined;
  status?: string | undefined;
  changeDate?: Date | undefined;
  rentalUnitId?: string | undefined;
  rentalSpace?: number | undefined;
  occupationType?: string | undefined;
  deviatorRent?: number | undefined;
  deleteDate?: Date | undefined;
  deposit?: number | undefined;
  deviatOrDeposit?: number | undefined;
  minimumRentalTime?: number | undefined;
  rentalUnit?: PmRentalUnit | undefined;
  fmDocument?: FmDocument[] | undefined;
  fmIncident?: FmIncident[] | undefined;
  pmPropertyBrochureAttribute?: PmPropertyBrochureAttribute[] | undefined;
  pmPropertyBrochureAvailability?: PmPropertyBrochureAvailability[] | undefined;
}

export interface PmPropertyBrochureAttribute {
  propertyBrochureAttributeId?: string | undefined;
  description?: string | undefined;
  descriptionEn?: string | undefined;
  statuscode?: string | undefined;
  propertyBrochureId?: string | undefined;
  name: string;
  nameEn?: string | undefined;
  attributeClass?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  propertyBrochure?: PmPropertyBrochure | undefined;
}

export interface PmPropertyBrochureAvailability {
  propertyBrochureAvailabilityId?: string | undefined;
  statusCode?: string | undefined;
  propertyBrochureId: string;
  name?: string | undefined;
  moveInDate?: Date;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  propertyBrochure?: PmPropertyBrochure | undefined;
  fmIncident?: FmIncident[] | undefined;
}

export interface PmRentalUnitArchObj {
  archObjId?: string | undefined;
  rentalUnitId?: string | undefined;
  altenrateKey?: string | undefined;
  validFrom?: Date | undefined;
  validUnitl?: Date | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  archObj?: DtArchObjHierarchy | undefined;
  rentalUnit?: PmRentalUnit | undefined;
}

export interface RentalContractSpace {
  id?: string | undefined;
  rentalContractId?: string | undefined;
  economicUnitArchObjId?: string | undefined;
  landArchObjId?: string | undefined;
  buildingArchObjId?: string | undefined;
  spaceArchObjId?: string | undefined;
  changeDate?: Date | undefined;
  buildingArchObj?: DtArchObjHierarchy | undefined;
  economicUnitArchObj?: DtArchObjHierarchy | undefined;
  landArchObj?: DtArchObjHierarchy | undefined;
  rentalContract?: PmRentalContract | undefined;
  spaceArchObj?: DtArchObjHierarchy | undefined;
}

export interface OmContactAuthorization {
  archObjAuthorizationId?: string | undefined;
  contactId: string;
  archObjId: string;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  archObj?: DtArchObjHierarchy | undefined;
  contact?: OmContact | undefined;
}

export interface FmBookableRessource {
  bookableResourceId?: string | undefined;
  resourceType?: string | undefined;
  name?: string | undefined;
  startLocation?: string | undefined;
  endLocation?: string | undefined;
  displayOnScheduleBoard?: boolean | undefined;
  organisationalUnitId?: string | undefined;
  hourlyRate?: number | undefined;
  primaryEmail?: string | undefined;
  displayOnScheduleAssistant?: boolean | undefined;
  contactId?: string | undefined;
  accountId?: string | undefined;
  calendarId?: string | undefined;
  poolType?: string | undefined;
  hourlyRateBase?: number | undefined;
  deriveCapacity?: boolean | undefined;
  deleteDate?: Date | undefined;
  userId?: string | undefined;
  account?: OmOrganisation | undefined;
  contact?: OmContact | undefined;
  organisationalUnit?: OmOrganisationalUnit | undefined;
  user?: OmSystemUser | undefined;
  eventTeam?: EventTeam[] | undefined;
  fmBookableResourceBookableResourceChildBookableResource?:
    FmBookableResourceBookableResource[] | undefined;
  fmBookableResourceBookableResourceParentBookableResource?:
    FmBookableResourceBookableResource[] | undefined;
  fmWorkOrder?: FmWorkOrder[] | undefined;
  productionTeam?: ProductionTeam[] | undefined;
}

export interface OmOrganisationalUnit {
  organisationalUnitId?: string | undefined;
  name?: string | undefined;
  deleteDate?: Date | undefined;
  fmBookableRessource?: FmBookableRessource[] | undefined;
  fmWorkOrder?: FmWorkOrder[] | undefined;
}

export interface EventTeam {
  id?: string | undefined;
  eventId?: string | undefined;
  teamMemberId?: string | undefined;
  description?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  bookableResourceCategoryId?: string | undefined;
  bookableResourceCategory?: FmBookableResourceCategory | undefined;
  event?: Event | undefined;
  teamMember?: FmBookableRessource | undefined;
}

export interface FmBookableResourceCategory {
  id?: string | undefined;
  name: string;
  description?: string | undefined;
  eventTeam?: EventTeam[] | undefined;
  fmWorkOrderServiceTask?: FmWorkOrderServiceTask[] | undefined;
  productionTeam?: ProductionTeam[] | undefined;
}

export interface FmWorkOrderServiceTask {
  workOrderServiceTaskId?: string | undefined;
  workOrderId?: string | undefined;
  serviceTaskTypeId?: string | undefined;
  description?: string | undefined;
  name: string;
  maintenanceGroupId?: string | undefined;
  completed?: boolean | undefined;
  checkListId?: string | undefined;
  taskPosition?: number | undefined;
  deleteDate?: Date | undefined;
  endDate?: Date | undefined;
  checkList?: FmChecklistVersion | undefined;
  maintenanceGroup?: FmBookableResourceCategory | undefined;
  serviceTaskType?: FmServiceTaskType | undefined;
  workOrder?: FmWorkOrder | undefined;
  fmChecklistResponse?: FmChecklistResponse[] | undefined;
}

export interface FmChecklistVersion {
  id?: string | undefined;
  title: string;
  description?: string | undefined;
  requiredToAnswer?: boolean;
  version?: number;
  versionNumber: string;
  checkListId: string;
  checkList?: FmChecklist | undefined;
  fmChecklistGroup?: FmChecklistGroup[] | undefined;
  fmWorkOrderServiceTask?: FmWorkOrderServiceTask[] | undefined;
}

export interface FmChecklist {
  id?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  fmChecklistVersion?: FmChecklistVersion[] | undefined;
  fmServiceTaskType?: FmServiceTaskType[] | undefined;
}

export interface FmServiceTaskType {
  id?: string | undefined;
  name: string;
  description?: string | undefined;
  estimatedDuration?: number | undefined;
  inspectionEnabled?: boolean | undefined;
  inspectionId?: string | undefined;
  deleteDate?: Date | undefined;
  checkListId?: string | undefined;
  checkList?: FmChecklist | undefined;
  fmWorkOrderServiceTask?: FmWorkOrderServiceTask[] | undefined;
}

export interface FmChecklistGroup {
  id?: string | undefined;
  title: string;
  description?: string | undefined;
  name: string;
  checkListVersionId: string;
  checkListVersion?: FmChecklistVersion | undefined;
  fmChecklistEntry?: FmChecklistEntry[] | undefined;
}

export interface FmChecklistEntry {
  id?: string | undefined;
  checklistGroupId: string;
  name: string;
  required?: boolean | undefined;
  title?: string | undefined;
  checklistEntryType?: number;
  dataType?: string | undefined;
  checklistGroup?: FmChecklistGroup | undefined;
  fmChecklistEntryChoice?: FmChecklistEntryChoice[] | undefined;
  fmChecklistResponse?: FmChecklistResponse[] | undefined;
}

export interface FmChecklistEntryChoice {
  id?: string | undefined;
  checklistEntryId: string;
  order?: number;
  text?: string | undefined;
  checklistEntry?: FmChecklistEntry | undefined;
}

export interface FmChecklistResponse {
  id?: string | undefined;
  checklistEntryId: string;
  workOrderServiceTaskId: string;
  charResponse?: string | undefined;
  numResponse?: number | undefined;
  dateResponse?: Date | undefined;
  boolResponse?: boolean | undefined;
  checklistEntry?: FmChecklistEntry | undefined;
  workOrderServiceTask?: FmWorkOrderServiceTask | undefined;
}

export interface ProductionTeam {
  id?: string | undefined;
  productionId?: string | undefined;
  teamMemberId?: string | undefined;
  description?: string | undefined;
  subsectionId?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  bookableResourceCategoryId?: string | undefined;
  bookableResourceCategory?: FmBookableResourceCategory | undefined;
  production?: Production | undefined;
  subsection?: SysEnum | undefined;
  teamMember?: FmBookableRessource | undefined;
}

export interface FmBookableResourceBookableResource {
  id?: string | undefined;
  name: string;
  parentBookableResourceId: string;
  childBookableResourceId: string;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  childBookableResource?: FmBookableRessource | undefined;
  parentBookableResource?: FmBookableRessource | undefined;
}

export interface WorkOrderPosition {
  id?: string | undefined;
  stateDetailsOffer?: string | undefined;
  title?: string | undefined;
  requesterId?: string | undefined;
  eventMatchcode?: string | undefined;
  offerId?: string | undefined;
  productFamiliyId?: string | undefined;
  productId?: string | undefined;
  serviceProviderId?: string | undefined;
  stornoWithoutCosts?: boolean | undefined;
  stornoCosts?: number | undefined;
  tenderWasNecessary?: boolean | undefined;
  timeRevision?: boolean | undefined;
  workorderPositionRevision?: string | undefined;
  completionDate?: Date | undefined;
  deadlineMet?: boolean | undefined;
  organizationalDeadlineProduct?: number | undefined;
  organizationalDeadline?: Date | undefined;
  requestCancellation?: boolean | undefined;
  buildingStart?: Date | undefined;
  buildingEnd?: Date | undefined;
  esaInspection?: Date | undefined;
  customerInspection?: Date | undefined;
  technicalEventRunTimeStart?: Date | undefined;
  technicalEventRunTimeEnd?: Date | undefined;
  securityRunTimeStart?: Date | undefined;
  securityRunTimeEnd?: Date | undefined;
  runTimeChanged?: boolean | undefined;
  layer01?: string | undefined;
  layer02?: string | undefined;
  layer?: number | undefined;
  pricelist?: string | undefined;
  budgetPositionId?: string | undefined;
  unitPrice?: number | undefined;
  externalPrice?: number | undefined;
  amount?: number | undefined;
  totalPrice?: number | undefined;
  productionId?: string | undefined;
  workOrderId: string;
  product?: FmProduct | undefined;
  production?: Production | undefined;
  requester?: OmSystemUser | undefined;
  workOrder?: FmWorkOrder | undefined;
  document?: Document[] | undefined;
  workOrderPositionHall?: WorkOrderPositionHall[] | undefined;
}

export interface WorkOrderPositionHall {
  id?: string | undefined;
  name?: string | undefined;
  ownerId?: string | undefined;
  usagePeriodStartDate?: Date | undefined;
  usagePeriodEndDate?: Date | undefined;
  workorderPositionId?: string | undefined;
  eventId?: string | undefined;
  dispoStart?: Date | undefined;
  dispoEnd?: Date | undefined;
  endDate?: Date | undefined;
  notes?: string | undefined;
  amount?: number | undefined;
  bookedHallId?: string | undefined;
  closed?: boolean | undefined;
  statusId?: string | undefined;
  amountActual?: number | undefined;
  bookedHall?: BookedHall | undefined;
  event?: Event | undefined;
  owner?: OmSystemUser | undefined;
  status?: SysEnum | undefined;
  workorderPosition?: WorkOrderPosition | undefined;
}

export interface FmIncidentType {
  incidentTypeId?: string | undefined;
  litArtCode?: string | undefined;
  regIsDataRetrieval?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  name?: string | undefined;
  fmIncident?: FmIncident[] | undefined;
  fmWorkOrder?: FmWorkOrder[] | undefined;
}

export interface FmWorkOrderType {
  workOrderTypeId?: string | undefined;
  name?: string | undefined;
  importSequenceNumber?: string | undefined;
  priceListId?: string | undefined;
  taxable?: boolean | undefined;
  deleteDate?: Date | undefined;
  priceList?: FmPriceList | undefined;
  fmWorkOrder?: FmWorkOrder[] | undefined;
}

export interface Complaint {
  id?: string | undefined;
  complaintTypeId?: string | undefined;
  site?: string | undefined;
  description?: string | undefined;
  detailedLocation?: string | undefined;
  eventId?: string | undefined;
  productionId?: string | undefined;
  workOrderId?: string | undefined;
  contactedOn?: Date | undefined;
  subject?: string | undefined;
  complaintType?: SysEnum | undefined;
  event?: Event | undefined;
  production?: Production | undefined;
  workOrder?: FmWorkOrder | undefined;
}

export interface FmWorkOrderMilestone {
  workOrderId?: string | undefined;
  milestoneNo?: number;
  fixedDate?: Date | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  workOrder?: FmWorkOrder | undefined;
}

export interface WorkOrderPrecondition {
  id?: string | undefined;
  name?: string | undefined;
  workOrderId: string;
  predecessorWorkOrderId: string;
  statusId?: string | undefined;
  predecessorWorkOrder?: FmWorkOrder | undefined;
  status?: SysEnum | undefined;
  workOrder?: FmWorkOrder | undefined;
}

export interface FiCostCenter {
  costCenterId?: string | undefined;
  name: string;
  type?: string | undefined;
  organisationId?: string | undefined;
  changeDate?: Date | undefined;
  number?: string | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  deleteDate?: Date | undefined;
  organisation?: OmOrganisation | undefined;
  fmIncident?: FmIncident[] | undefined;
}

export interface FmIncidentClass {
  incidentClassId?: string | undefined;
  incidentClass: string;
  incidentType: string;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  fmConfigurationTask?: FmConfigurationTask[] | undefined;
  fmIncident?: FmIncident[] | undefined;
}

export interface FmConfigurationTask {
  configurationTaskId?: string | undefined;
  isActive?: boolean | undefined;
  subject?: string | undefined;
  description?: string | undefined;
  incidentClassId?: string | undefined;
  priorityCode?: string | undefined;
  dueDays?: number | undefined;
  accountId?: string | undefined;
  sendToPortal?: boolean | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  account?: OmOrganisation | undefined;
  incidentClass?: FmIncidentClass | undefined;
  fmConfigurationRow?: FmConfigurationRow[] | undefined;
  fmTask?: FmTask[] | undefined;
}

export interface FmConfigurationRow {
  configurationRowId?: string | undefined;
  isActive?: boolean | undefined;
  titleDe?: string | undefined;
  titleEn?: string | undefined;
  fieldName?: string | undefined;
  configurationTaskId: string;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  name?: string | undefined;
  length?: number | undefined;
  optionSetType?: string | undefined;
  configurationTask?: FmConfigurationTask | undefined;
}

export interface FmTask {
  taskId?: string | undefined;
  isActive?: boolean | undefined;
  dueDays?: number | undefined;
  subject?: string | undefined;
  description?: string | undefined;
  result?: string | undefined;
  status?: string | undefined;
  dueDate?: Date | undefined;
  configurationTaskId?: string | undefined;
  incidentId?: string | undefined;
  organisationId?: string | undefined;
  deleteDate?: Date | undefined;
  externalProcessorId?: string | undefined;
  configurationTask?: FmConfigurationTask | undefined;
  externalProcessor?: OmContact | undefined;
  incident?: FmIncident | undefined;
  organisation?: OmOrganisation | undefined;
  fmDocument?: FmDocument[] | undefined;
}

export interface FmIncidentGrading {
  incidentGradingId?: string | undefined;
  name?: string | undefined;
  deleteDate?: Date | undefined;
  fmIncident?: FmIncident[] | undefined;
}

export interface FmRoutingType {
  routingTypeId?: string | undefined;
  name: string;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  fmIncident?: FmIncident[] | undefined;
}

export interface FmSla {
  slaId?: string | undefined;
  description: string;
  allowePauseResume?: boolean | undefined;
  slaType?: string | undefined;
  applicableFrom?: Date | undefined;
  alternateKey?: string | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  fmIncident?: FmIncident[] | undefined;
  fmQuote?: FmQuote[] | undefined;
}

export interface EventCharacter {
  eventId?: string | undefined;
  characterId?: string | undefined;
  character?: SysEnum | undefined;
  event?: Event | undefined;
}

export interface EventCharacter1 {
  eventId?: string | undefined;
  enumId?: string | undefined;
  enum?: SysEnum | undefined;
}

export interface SysEnumTranslation {
  id?: string | undefined;
  enumId: string;
  language: string;
  name: string;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
  enum?: SysEnum | undefined;
}

export interface FmDocumentType {
  documentTypeId?: string | undefined;
  abbreviation?: string | undefined;
  name?: string | undefined;
  externalCode?: string | undefined;
  gefmaCode?: string | undefined;
  deleteDate?: Date | undefined;
  isExternal?: boolean;
  fmDocument?: FmDocument[] | undefined;
}

export interface DownloadFile {
  id?: string | undefined;
}

export interface DownloadFileResult {
  link?: string | undefined;
}

export interface CreateIncidentFromPortalDTO {
  incidentDTO?: AddIncidentDTO;
  files?: UploadFile[] | undefined;
}

export interface AddIncidentDTO {
  buildingPart?: string | undefined;
  deviatingAddress?: string | undefined;
  floorId?: string | undefined;
  incidentTitle?: string;
  incidentClass?: string;
  incidentType?: IncidentType | undefined;
  incidentClassMiscText?: string | undefined;
  incidentDescription?: string;
  contactInformation?: string | undefined;
  powerOfDisposition?: string | undefined;
  externalProductId?: string | undefined;
  roomNumber?: string | undefined;
  targetLocation?: AddressDTO | undefined;
  concerningLocation?: AddressDTO | undefined;
  requestingContact?: ContactDTO;
  concerningContact?: ContactDTO | undefined;
  requestSource?: RequestSource | undefined;
}

export enum IncidentType {
  Eigentuemerbelange = 0,
  Mietmanagement = 1,
  Serviceanfrage = 2,
}

export interface AddressDTO {
  city?: string | undefined;
  zipcode?: string | undefined;
  street?: string | undefined;
  state?: string | undefined;
  plotNumber?: string | undefined;
  additionalInformation?: string | undefined;
}

export interface ContactDTO {
  firstname?: string;
  lastname?: string;
  salutation?: string | undefined;
  jobTitle?: string | undefined;
  email?: string;
  phonenumber?: string;
  accountString?: string | undefined;
  address?: AddressDTO;
  subscribeNewsletter?: boolean | undefined;
}

export enum RequestSource {
  TaskModule = 0,
  LandingPage = 1,
}

export interface CreateIncidentAuthenticatedFromPortalDTO {
  incidentDTO?: AddIncidentAuthenticatedDTO;
  files?: UploadFile[] | undefined;
}

export interface AddIncidentAuthenticatedDTO {
  incidentTitle: string;
  incidentDescription: string;
  incidentClass?: string | undefined;
  incidentType?: IncidentType | undefined;
  createdById: string;
  functionalLocationId?: string | undefined;
  alternateAddress?: AddressDTO | undefined;
  shouldUserReceiveAcknowledgement?: boolean;
}

export interface SmartPortalErrorDetails {
  errorCode?: SmartPortalProcessError;
  message?: string | undefined;
}

export enum SmartPortalProcessError {
  USER_DOES_NOT_EXIST_IN_DATABASE = 0,
  GUARD_CLAUSE_FAILED = 1,
  USER_IS_NOT_UNIQUE = 2,
  USER_HAS_NO_ORGANISATIONID = 3,
  ID_NOT_VALID = 4,
  DATA_FOR_ID_NOT_FOUND = 5,
  SEARCH_VALUE_TOO_SHORT = 6,
  OFFERING_RESERVATION_WITH_EMAIL_ALREADY_EXISTS = 1001,
  EXPOSE_CANT_BE_BOOKED_WITH_GIVEN_PARAMS = 1002,
  EXPOSE_COULD_NOT_BE_FOUND = 1003,
  USER_MANDANT_IS_NOT_ALLOWED_TO_ACCESS_VIEW = 2000,
  USER_IS_NOT_ALLOWED_TO_ACCESS_INCIDENT = 2001,
  COULD_NOT_DETERMINE_LOCATION_FOR_INCIDENT_CREATION = 2002,
  USER_IS_NOT_ALLOWED_TO_ACCESS_VIEW = 2003,
  TASK_COULD_NOT_BE_FOUND_OR_ACCESSED = 3000,
  CONFIGURATION_ROW_HAS_NO_VALID_NAME = 3001,
  COULD_NOT_RESOLVE_ATTRIBUTE_NAME = 3002,
  WORKORDER_COULD_NOT_BE_FOUND_OR_ACCESSED = 4000,
  FUNCTIONAL_LOCATION_COULD_NOT_BE_ACCESSED = 4001,
  USER_HAS_NO_RENTAL_CONTRACT = 5000,
  USER_HAS_ACTIVE_TERMINATION_REQUEST = 5001,
  USER_ID_NOT_RETRIEVABLE = 5002,
  USER_HAS_NO_RELEVANT_GROUP = 5003,
  USERTOKEN_DOES_NOT_INCLUDE_EMAIL = 6000,
  B2C_MAIL_ALREADY_USED = 8001,
  B2C_USER_NOT_ASSIGNED_TO_MANDANT = 8002,
  DATACONTRACT_PROBABLY_NOT_UP_TO_DATE = 10000,
}

export interface CreatePasmIncidentRequestDTO {
  archObjId: string;
  deadline?: Date;
  description?: string;
  incidentType?: PasmIncidentType;
  notifyingContactId: string;
  files?: UploadFile[] | undefined;
}

export enum PasmIncidentType {
  Flaechenanfrage = 1,
  Grundstuecksanfrage = 2,
  Prognose = 3,
  Rueckmietbedarf = 4,
  EigentuemerwuenscheGsus = 6,
  AbbauAlttechnikPti = 7,
  Betriebsstellenverlagerung = 8,
}

export interface CreateOfferingReservationFromPortalDTO {
  offeringReservation?: AddOfferingReservationDTO;
  files?: UploadFile[] | undefined;
}

export interface AddOfferingReservationDTO {
  propertyBrochureId?: string;
  plannedMoveInDate?: Date;
  plannedMoveOutDate?: Date;
  arrivalDate?: Date;
  contactRelation?: ContactRelationship;
  rentingContact?: OfferingReservationContactDTO;
  additionalContact?: OfferingReservationContactDTO | undefined;
}

export enum ContactRelationship {
  Erziehungsberechtigter = 0,
  Verwandter = 1,
  Arbeitgeber = 2,
  StudienkollegSchule = 3,
  Ausbildungsbetrieb = 4,
  Umzugsfirma = 5,
}

export interface OfferingReservationContactDTO {
  firstname?: string;
  lastname?: string;
  email?: string;
  phonenumber?: string;
  amountOfChildren?: number | undefined;
  nationalityEnumId?: string | undefined;
  nationality?: string | undefined;
  dateOfBirth?: Date | undefined;
  gender?: GenderDTO | undefined;
  occupation?: OccupationType | undefined;
  occupationFacility?: string | undefined;
  preferredLanguage?: PreferredLanguage | undefined;
  subscribeNewsletter?: boolean | undefined;
  consentDigitalSignature?: boolean | undefined;
}

export enum GenderDTO {
  Diverse = 0,
  Female = 1,
  Male = 2,
}

export enum OccupationType {
  Studierende = 0,
  Auszubildende = 1,
  ArbeitnehmerInnen = 2,
  YoungProfessionals = 3,
  PraktikantInnen = 4,
  SprachschuelerInnen = 5,
  PhDStudentInnnen = 6,
  DoktorandInnen = 7,
  FSJLeistende = 8,
  PostdoktorandInnen = 9,
  GastwissenschaftlerInnen = 10,
}

export enum PreferredLanguage {
  Deutsch = 0,
  English = 1,
}

export interface IncidentViewModel {
  incidentId?: string;
  name?: string;
  archObjId?: string;
  description?: string;
  ticketNumber?: string;
  statusReason?: string;
  deadline?: Date | undefined;
  changeDate?: Date | undefined;
  createdOn?: Date | undefined;
  externalCompletion?: Date | undefined;
  archObj?: DtArchObjHierarchy;
  notifyingContact?: ContactViewModel;
  fmDocument?: FmDocument[];
  statusNavigation?: SysEnum;
  statusReasonNavigation?: SysEnum;
  incidentClass?: IncidentClassViewModel;
  archObjViewModel?: ArchObjViewModel | undefined;
  hasDocuments?: boolean;
  fmTask?: FmTask[];
}

export interface ContactViewModel {
  contactId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  telephone?: string;
}

export interface IncidentClassViewModel {
  incidentClass?: string;
}

export interface ArchObjViewModel {
  name?: string;
  changeDate?: Date | undefined;
}

export interface ResultWrapperOfIncidentViewModel {
  entites?: IncidentViewModel[];
  totalCount?: number;
}

export interface BaseSearchOptions {
  orderOptions?: OrderOptions | undefined;
  pagingOptions?: PagingOptions | undefined;
}

export interface IncidentSearchOptions extends BaseSearchOptions {
  filterOptions?: IncidentFilterOptions | undefined;
  viewOptions?: IncidentViewOptions | undefined;
}

export interface BaseFilterOptions {
  streetName?: string | undefined;
  postalCode?: string | undefined;
  city?: string | undefined;
}

export interface IncidentFilterOptions extends BaseFilterOptions {
  ticketNumber?: string | undefined;
  locationIdList?: string[] | undefined;
  name?: string | undefined;
  statusreasonList?: string[] | undefined;
  createDateFrom?: Date | undefined;
  createDateRange?: (Date | undefined)[] | undefined;
  deadlineDate?: Date | undefined;
  externalCompletionDateRange?: (Date | undefined)[] | undefined;
  createDateTo?: Date | undefined;
  status?: string | undefined;
  ticketTaskSelection?: string | undefined;
  ticketClass?: string | undefined;
  economicUnit?: string | undefined;
  statusReason?: string | undefined;
}

export interface IncidentViewOptions {
  selectCountOnly?: boolean | undefined;
  selectedView?: IncidentViews | undefined;
}

export enum IncidentViews {
  CreatedByMe = 0,
  VisibleForMe = 1,
  VisibleByTaskAssociation = 2,
  AllIncidents = 3,
  VisibleByOneTaskAssociation = 4,
}

export interface OrderOptions {
  attributeName: string;
  orderDirection: OrderDirection;
}

export enum OrderDirection {
  None = 0,
  Asc = 1,
  Desc = 2,
}

export interface PagingOptions {
  skip: number;
  take: number;
}

export interface AddContractTerminationRequestDTO {
  incidentDescription: string;
  createdById: string;
  rentalContractId: string;
  terminatedTo: Date;
}

export interface GetIncidentDTO {
  ticketNumber: string;
  primaryContactEmail: string;
}

export interface ResultWrapperOfArchObjAutocompleteViewModel {
  entites?: ArchObjAutocompleteViewModel[];
  totalCount?: number;
}

export interface ArchObjAutocompleteViewModel {
  archObjId?: string;
  siteName?: string | undefined;
  siteAdditionalNumber?: string | undefined;
  vpsz?: string | undefined;
  address?: AddressViewModel | undefined;
}

export interface AddressViewModel {
  addressId?: string;
  name?: string;
  type?: string;
  streetName?: string;
  houseNumber?: string;
  additionalInformation?: string;
  apartmentNumber?: string;
  district?: string;
  city?: string;
  state?: string;
  country?: string;
  alternateKey?: string;
  postalCode?: string;
  longitude?: number | undefined;
  latitude?: number | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  changeDate?: Date | undefined;
}

export interface ArchObjHierarchyViewModel {
  archObjId?: string;
  parentArchObjId?: string;
  archObjType?: string;
  changeDate?: Date | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  dtArchObjAddress?: ArchObjToAddressViewModel[];
  dtArchObjInformation?: ArchObjInformationViewModel[];
  dtArchObjNews?: ArchObjNewsViewModel[];
  incidents?: ArchObjIncidentViewModel[];
}

export interface ArchObjToAddressViewModel {
  archObjId?: string;
  addressId?: string;
  address?: AddressViewModel;
}

export interface ArchObjInformationViewModel {
  archObjId?: string | undefined;
  text?: string | undefined;
  infoCategoryId?: string | undefined;
  isPublished?: boolean | undefined;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
}

export interface ArchObjNewsViewModel {
  archObjId?: string | undefined;
  text?: string | undefined;
  validFrom?: Date | undefined;
  validUntil?: Date | undefined;
  isPublished?: boolean;
  changeDate?: Date | undefined;
  deleteDate?: Date | undefined;
}

export interface ArchObjIncidentViewModel {
  incidentId?: string;
  name?: string;
  archObjId?: string;
  ticketNumber?: string;
  createdOn?: Date | undefined;
  room?: ArchObjViewModel | undefined;
}

export interface ApiRequest {
  userEmail?: string;
  businessUnitId?: string;
  realEstateId?: string;
  buildingId?: string;
  craftId?: string;
  roomIds?: string[] | undefined;
}

export interface ResultWrapperOfPmPropertyBrochure {
  entites?: PmPropertyBrochure[];
  totalCount?: number;
}

export interface OfferingSearchOptions extends BaseSearchOptions {
  filterOptions?: OfferingFilterOptions | undefined;
}

export interface OfferingFilterOptions {
  plannedMoveInDate?: Date | undefined;
  maxTotalRent?: number | undefined;
  minRentalSpace?: number | undefined;
  numberOfRooms?: number | undefined;
  occupation?: OccupationType | undefined;
}

export interface LocationFilterOptionSet {
  id?: string;
  name?: string;
  type?: string;
  order?: number;
}

export interface LocationFilterHierarchy extends LocationFilterOptionSet {
  children?: LocationFilterHierarchy[] | undefined;
}

export enum EnumType {
  Affinis_nationality = 0,
}

export interface ReadUsersResponse {
  users?: GraphUserDTO[];
}

export interface GraphUserDTO {
  id?: string;
  accountEnabled?: boolean | undefined;
  displayName?: string;
  givenName?: string;
  surname?: string;
  mail?: string;
  memberOf?: GraphGroupDTO[];
}

export interface GraphGroupDTO {
  id?: string;
  displayName?: string;
  description?: string;
}

export interface ReadUsersRequest {
  tenantId?: string;
  mandantId?: string;
  groupPrefixFilter?: string | undefined;
}

export interface ReadUserResponse extends GraphUserDTO {}

export interface UserRequestBase {
  tenantId?: string;
  mandantId?: string;
  userId?: string;
}

export interface ReadUserRequest extends UserRequestBase {
  groupPrefixFilter?: string | undefined;
}

export interface UpdateUserResponse extends GraphUserDTO {}

export interface UpdateUserRequest extends UserRequestBase {
  accountEnabled?: boolean | undefined;
  displayName?: string | undefined;
  givenName?: string | undefined;
  surname?: string | undefined;
  mail?: string | undefined;
}

export interface DeleteUserRequest extends UserRequestBase {
  deletedByUserId?: string;
}

export interface ReadGroupsResponse {
  groups?: GraphGroupDTO[];
}

export interface ReadGroupsRequest {
  tenantId?: string;
  groupPrefixFilter?: string | undefined;
}

export interface AddUserToGroupsResponse {
  groupsAddedCount?: number;
}

export interface AddUserToGroupsRequest {
  userId?: string;
  tenantId?: string;
  groupIds?: string[];
}

export interface RemoveUserFromGroupsResponse {
  groupsRemovedCount?: number;
}

export interface RemoveUserFromGroupsRequest {
  userId?: string;
  tenantId?: string;
  groupIds?: string[];
}

export interface UpdateUserProfileDTO {
  contactId: string;
  telephonenumber?: string | undefined;
  mobilePhonenumber?: string | undefined;
  preferredLanguageEnumId?: string | undefined;
  preferredContactMethodEnumId?: string | undefined;
  subscribeNewsletter?: boolean | undefined;
  deleteProfilePicture?: boolean | undefined;
  profilePictureBase64?: string | undefined;
}

export interface RoleRequestDTO {
  justification: string;
  roles: string[];
}

export interface ResultWrapperOfQuoteViewModel {
  entites?: QuoteViewModel[];
  totalCount?: number;
}

export interface QuoteViewModel {
  quoteId?: string;
  name?: string;
  quoteNumber?: string;
  revisionNumber?: number | undefined;
  status?: string;
  statusReason?: string;
  validUntil?: Date | undefined;
  termsOfPaymentCode?: string;
  netAmount?: number | undefined;
  tax?: number | undefined;
  totalAmount?: number | undefined;
  billingAddressCity?: string;
  billingAddressContactName?: string;
  billingAddressCountry?: string;
  billingAddressStreet1?: string;
  billingAddressStreet2?: string;
  billingAddressName?: string;
  billingAddressPostalCode?: string;
  billingAddressStateOrProvince?: string;
  billingAddressPhone?: string;
  fmQuoteDetail?: FmQuoteDetail[];
  incidentNavigation?: FmIncident | undefined;
  archObjViewModel?: ArchObjViewModel | undefined;
}

export interface QuoteSearchOptions extends BaseSearchOptions {
  filterOptions?: QuoteFilterOptions | undefined;
}

export interface QuoteFilterOptions {
  quoteNumber?: string | undefined;
  quoteTitle?: string | undefined;
  locationIdList?: string[] | undefined;
  quoteValidUntil?: Date | undefined;
  state?: string | undefined;
}

export interface ChangeQuoteStateDTO {
  quoteId?: string;
  reactingContactId?: string;
  responseText?: string | undefined;
  response?: boolean;
}

export interface RepresentativeResponse {
  representativeId?: string;
  representativeName?: string;
  representativeMail?: string;
}

export interface ResultWrapperOfFmTask {
  entites?: FmTask[];
  totalCount?: number;
}

export interface TaskSearchOptions extends BaseSearchOptions {
  filterOptions?: TaskFilterOptions | undefined;
}

export interface TaskFilterOptions extends BaseFilterOptions {
  subject?: string | undefined;
  description?: string | undefined;
  incidentId?: string | undefined;
  ticketNumber?: string | undefined;
  incidentTitle?: string | undefined;
  state?: string | undefined;
  dueDateFrom?: Date | undefined;
  dueDateTo?: Date | undefined;
  resultText?: string | undefined;
  taskSelection?: string | undefined;
  incidentClass?: string | undefined;
  economicUnit?: string | undefined;
  status?: string | undefined;
}

export interface ResultExtensionWrapperOfFmTaskAndIEnumerableOfIncidentFieldMapping {
  entity?: FmTask;
  extension?: IncidentFieldMapping[];
}

export interface IncidentFieldMapping {
  ibpdiAttributeName: string;
  targetAttributeName: string;
  ibpdiAttributeType: string;
  optionSetType?: string | undefined;
}

export interface UpdateTaskDTO {
  userId: string;
  taskId: string;
  result: string;
  status: TaskStatus;
  updateIncidentDTO?: UpdateIncidentDTO | undefined;
}

export enum TaskStatus {
  InBearbeitung = 0,
  Abgeschlossen = 1,
  Storniert = 2,
}

export interface UpdateIncidentDTO {
  incident: FmIncident;
  fieldMapping: IncidentFieldMapping[];
}

export interface ResultWrapperOfWorkorderViewModel {
  entites?: WorkorderViewModel[];
  totalCount?: number;
}

export interface WorkorderViewModel {
  workOrderId?: string;
  name?: string;
  workOrderTitle?: string;
  workOrderSummary?: string;
  timeWindowStart?: Date | undefined;
  timeWindowEnd?: Date | undefined;
  systemstatus?: string;
  substatus?: string;
  primaryIncidentDescription?: string;
  bookingSummary?: string;
  city?: string;
  postalCode?: string;
  street?: string;
  houseNumber?: string;
  district?: string;
  createdOn?: Date | undefined;
  changeDate?: Date | undefined;
  location?: DtArchObjHierarchy;
  fmDocument?: FmDocument[];
  archObjViewModel?: ArchObjViewModel | undefined;
}

export interface WorkorderSearchOptions extends BaseSearchOptions {
  filterOptions?: WorkorderFilterOptions | undefined;
}

export interface WorkorderFilterOptions {
  name?: string | undefined;
  locationIdList?: string[] | undefined;
  workorderTitle?: string | undefined;
  statusReason?: number | undefined;
  timeWindowStartFrom?: Date | undefined;
  timeWindowStartTo?: Date | undefined;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
